import CourseUtil from './CourseUtil';
import L from 'leaflet';
import MapUtils from '../backbone/views/map/MapViewUtils';
import Util from '../backbone/views/utils/LeafletMap/utils/Util';
import MapUtil from '../backbone/views/utils/LeafletMap/utils/MapUtil';
import ElevationGainAnalyzer from '../backbone/utils/ElevationGainAnalyzer';
import ElevationLossAnalyzer from '../backbone/utils/ElevationLossAnalyzer';
import GeolocationUtil from '../backbone/utils/GeolocationUtil';
import Personalizer from 'personalizer';
import GarminOpenStreetMapProvider from 'views/utils/LeafletMap/MapProviders/GarminOpenStreetMapProvider';
import GoogleMapProvider from 'views/utils/LeafletMap/MapProviders/GoogleMapProvider';
import HereMapProvider from 'views/utils/LeafletMap/MapProviders/HereMapProvider';
import BaiduMapProvider from 'views/utils/LeafletMap/MapProviders/BaiduMapProvider';
import LeafletUtil from 'views/utils/LeafletMap/utils/Util';
import {
    ColorLimeLight2,
    ColorYellowDark1,
    ColorOrangeLight3,
    ColorRedLight3,
    Color306
} from 'ui-connect/styles/default-theme';

import {
    MAX_COURSE_DISTANCE_KM,
    MAX_COURSE_DISTANCE_MILES,
    MIN_COURSE_DISTANCE_KM,
    MIN_COURSE_DISTANCE_MILES,
    selectCourseUrl
} from '../PowerGuidance/PowerGuidanceUtils';

import {
    PACE_PRO_MAX_COURSE_DISTANCE_KM,
    PACE_PRO_MAX_COURSE_DISTANCE_MILES,
    PACE_PRO_MIN_COURSE_DISTANCE_KM,
    PACE_PRO_MIN_COURSE_DISTANCE_MILES
} from '../utils/pacePro/PaceProUtil';
import constants from '../Map/constants';
import { isChinaUser } from '../utils/ChinaUtil';
import { getFaqLink } from 'utils/LinksUtil';
import AnalyticsUtil from '../backbone/utils/AnalyticsUtil';
import i18next from 'i18next';
import { GarminTrailHash } from 'services/omt/subscription/subscriptionFields';
import { MARKER_MILE, MARKER_KILOMETER, MARKER_HALF_MARATHON } from 'constants/CoursesConstants';
import MapsUtil from 'lib/map/MapsUtil';
import Conversion from 'utils/Conversion';
import DistanceUnits from 'utils/personalizer/DistanceUnits';

i18next.loadNamespaces(['course', 'pacepro', 'units']);

export const MAX_COURSE_NAME_LENGTH = 128;
export const MAP_DEFAULT_ZOOM_LEVEL = 12;
export const DEFAULT_USER_LOCATION = MapUtils.userInChina() ? [39.92889, 116.38833] : [38.854699, -94.797763];
export const anchorIcon = [10, 24];
export const linePointMarkerUrl = '/modern/images/map/coursePointsIcons/map-marker-course-point.svg';
export const linePointMarkerUrlHover = '/modern/images/map/coursePointsIcons/map-marker-course-point-hover.svg';
export const linePointMarkerSize = [14, 14];
export const linePointMarkerAnchorIcon = [7, 7];
export const elevationPointMarkerSize = [18, 18];
export const elevationPointMarkerAnchorIcon = [8, 8];
export const genericPointMarkerUrl = '/modern/images/map/coursePointsIcons/map-marker-course-point-generic.svg';
export const endMarkerUrl = '/modern/images/map/coursePointsIcons/map-marker-end.svg';
export const startMarkerUrl = '/modern/images/map/coursePointsIcons/map-marker-start.svg';
export const genericPointMarkerHoverUrl =
    '/modern/images/map/coursePointsIcons/map-marker-course-point-generic-reverse.svg';
export const START_MARKER = 'startMarker';
export const END_MARKER = 'endMarker';
export const anchorIconSize = [20, 28];
export const anchorCoursePointIcon = [10, 10];
export const anchorCoursePointIconSize = [22, 22];
export const MaxPopularityRouteDistanceInKm = 500;
export const CHART_AXIS_VALUES = {
    Y: 'elevation',
    X: 'distance'
};
export const GroupRoleTypes = {
    ADMIN: 'ADMIN',
    MEMBER: 'MEMBER'
};
export const START_FINISH_COURSE_POINT_TYPES = {
    start: 'START_TYPE',
    finish: 'FINISH_TYPE'
};
const { mapProviderInfo } = constants;
//MAP_PROVIDER_KEY used to store map provider such as google here or baidu
export const MAP_PROVIDER_KEY = 'map_provider_type';
export const SERVICE_TILE_HOST_KEY = 'service.tile.host';
export const DEFAULT_MAP_PROVIDER_VALUE = 'google';
export const DEFAULT_MAP_PROVIDER_VALUE_CHINA = 'baidu';
export const ALLOW_RUNNING_POPULAR_ROUTING_KEY = 'CourseCreator.AllowRunningPopularityRouting';
export const HAZARDS_NOTICE_DISMISSED_KEY = 'CourseCreator.HazardsNoticeDismissed';
export const FIRST_CYCLING_COURSE_CREATE_TOOLTIP_DISMISSED_KEY =
    'CourseCreator.FirstCyclingCourseCreateTooltipDismissed';
//MAP_SETTINGS_COURSES_KEY is used for map layout (satellite/terrain) but also popularityHeatMap, lapMarkers and many more
export const MAP_SETTINGS_COURSES_KEY = 'Map.Setting.Courses';
export const DEFAULT_MAP_SETTINGS_COURSES_VALUE =
    '{"courseMarkers":true,"lapMarkers":false,"popularityHeatMap":"none", "popularityHeatMapCheckStatus": true, "trails": true, "climbs": false}';
export const CLIMBS_KEY = 'Map.Setting.Climbs';
export const CLIMBS_SURFACE_KEY = 'Map.Setting.ClimbsSurface';
export const DEFAULT_LIST_SIZE_INCREMENT_VALUE = 10;
export const NEARBY_LIST_FETCH_SIZE = 200;
export const VIRTUAL_PARTNER_LEAN_MORE_LINK = getFaqLink('9aaItduDZd4rzKRriZKTp9');
export const MAX_REST_BREAK_DURATION_SECONDS = 3599;
export const MAX_CUTOFF_DURATION_SECONDS = 359999;

export const ADD_COURSE_POINT_BUTTON_QUERY_PARAM = 'addCoursePointButtonFromView';
export const EDIT_COURSE_POINT_BUTTON_LIST_QUERY_PARAM = 'editCoursePointButtonFromList';
export const EDIT_COURSE_POINT_BUTTON_MAP_QUERY_PARAM = 'editCoursePointButtonFromMap';

export const CLICK_FROM_MAP = 'map';
export const CLICK_FROM_LIST = 'list';

//taken from CourseCreateNewView.js
export const SourceTypeId = {
    FromActivity: 1,
    System: 2,
    Manual: 3,
    [GarminTrailHash]: 4
};

//taken form CourseDrawingRoundTripCardView.js
export const DistanceDefaultsInKM = {
    cycling: 15.4,
    running: 5
};

//taken form Course.js
export const RulesDTO = {
    public: {
        id: 1,
        key: 'public'
    },
    private: {
        id: 2,
        key: 'private'
    }
};

export const Directions = {
    RANDOM: 'random',
    SOUTH: 'south',
    NORTH: 'north',
    EAST: 'east',
    WEST: 'west'
};

export const COURSE_LIST_TABS = {
    USERS_COURSES: {
        value: 'Owner',
        tabIndex: 0
    },
    FAVORITES: {
        value: 'Favorites',
        tabIndex: 1
    },
    NEARBY: {
        value: 'Public',
        tabIndex: 2
    }
};

//the preference key is courseListSort
export const COURSE_LIST_FILTER_TYPES = [
    {
        value: 'CREATED_DATE_DESC',
        preferenceValue: 'recent',
        label: 'course_map_list_sort_by_recently_created'
    },
    {
        value: 'NAME_ASC',
        preferenceValue: 'course-name-asc',
        label: 'course_map_list_sort_by_course_name_ascending'
    },
    {
        value: 'NAME_DESC',
        preferenceValue: 'course-name-desc',
        label: 'course_map_list_sort_by_course_name_descending'
    },
    {
        value: 'DISTANCE_ASC',
        preferenceValue: 'shortest-distance',
        label: 'course_map_list_sort_by_shortest_distance'
    },
    {
        value: 'DISTANCE_DESC',
        preferenceValue: 'longest-distance',
        label: 'course_map_list_sort_by_longest_distance'
    }
];

const COURSE_POINT_DISTANCE_BUFFER_METERS = 50;
const COURSE_POINT_DISTANCE_THRESHOLD_METERS = 25;
const COURSE_POINT_DEFAULT_LENGTH = 10;

export const sortListByFilterValue = (list, sortValue) => {
    let newList = [...list];

    if (sortValue && newList.length) {
        if (sortValue === COURSE_LIST_FILTER_TYPES[0].preferenceValue) {
            return newList.sort((a, b) => (a.createdDate < b.createdDate ? 1 : b.createdDate < a.createdDate ? -1 : 0));
        } else if (sortValue === COURSE_LIST_FILTER_TYPES[1].preferenceValue) {
            return newList.sort((a, b) => {
                if (!a.courseName || !b.courseName) {
                    return 0;
                }
                return a.courseName.toUpperCase().localeCompare(b.courseName.toUpperCase());
            });
        } else if (sortValue === COURSE_LIST_FILTER_TYPES[2].preferenceValue) {
            return newList.sort((a, b) => {
                if (!a.courseName || !b.courseName) {
                    return 0;
                }
                return b.courseName.toUpperCase().localeCompare(a.courseName.toUpperCase());
            });
        } else if (sortValue === COURSE_LIST_FILTER_TYPES[3].preferenceValue) {
            return newList.sort((a, b) =>
                a.distanceInMeters > b.distanceInMeters ? 1 : b.distanceInMeters > a.distanceInMeters ? -1 : 0
            );
        } else if (sortValue === COURSE_LIST_FILTER_TYPES[4].preferenceValue) {
            return newList.sort((a, b) =>
                a.distanceInMeters < b.distanceInMeters ? 1 : b.distanceInMeters < a.distanceInMeters ? -1 : 0
            );
        }
    }

    return newList;
};

export const filterCourseList = (list, filters) => {
    let newList = [...list];

    if (newList && newList.length && filters) {
        if (filters && filters.courseTypes && filters.courseTypes.length) {
            newList = newList.filter((item) => {
                return filters.courseTypes.indexOf(item.activityTypeId.typeKey) !== -1;
            });
        }
        if (filters && filters.courseName && filters.courseName.length) {
            newList = newList.filter((item) => {
                //remove case sensitivity
                return item.courseName.toUpperCase().indexOf(filters.courseName.toUpperCase()) !== -1;
            });
        }
        if (filters && filters.minDistance) {
            newList = newList.filter((item) => {
                return item.distanceInMeters >= filters.minDistanceInMeters;
            });
        }
        if (filters && filters.maxDistance) {
            newList = newList.filter((item) => {
                return item.distanceInMeters <= filters.maxDistanceInMeters;
            });
        }
        if (filters && filters.minAscent) {
            newList = newList.filter((item) => {
                return item.elevationGainInMeters >= filters.minAscentInMeters;
            });
        }
        if (filters && filters.maxAscent) {
            newList = newList.filter((item) => {
                return item.elevationGainInMeters <= filters.maxAscentInMeters;
            });
        }
    }

    return newList;
};

/**
 * filters the courses based on the startLatitude and startLongitude
 * @param courseList {*[]}
 * @param bounds {{ north: number, east: number, south: number, west: number }}
 * @returns {*[]}
 */
export const filterCourseListByMapBounds = (list, bounds) => {
    let newList = [...list];

    if (newList && newList.length && bounds) {
        newList = newList.filter((item) => {
            return (
                item.startLatitude <= bounds.north &&
                item.startLatitude >= bounds.south &&
                item.startLongitude <= bounds.east &&
                item.startLongitude >= bounds.west
            );
        });
    }

    return newList;
};

//taken form courses/utils/Utils.js but added extra customGroupTitle, iconName
export const CourseTypes = [
    {
        value: 'activity_type_road_cycling',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'road_biking',
        group: 1,
        customGroupTitle: 'activity_type_cycling',
        iconName: 'icon-activity-cycling',
        mapMarkerIconName: 'map-marker-course-cycling',
        parentType: 'cycling'
    },
    {
        value: 'activity_type_gravel_cycling',
        shortValue: 'course_map_filter_options_gravel_unpaved',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'gravel_cycling',
        group: 1,
        customGroupTitle: 'activity_type_cycling',
        iconName: 'icon-cycling-gravel',
        mapMarkerIconName: 'map-marker-course-gravel-cycling',
        parentType: 'cycling'
    },
    {
        value: 'activity_type_mountain_biking',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'mountain_biking',
        group: 1,
        customGroupTitle: 'activity_type_cycling',
        iconName: 'icon-cycling-MTB',
        mapMarkerIconName: 'map-marker-course-mtb-cycling',
        parentType: 'cycling'
    },
    {
        value: 'activity_type_running',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'running',
        group: 2,
        customGroupTitle: 'activity_type_running',
        iconName: 'icon-activity-running',
        mapMarkerIconName: 'map-marker-course-running',
        parentType: 'running'
    },
    {
        value: 'activity_type_trail_running',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'trail_running',
        group: 2,
        customGroupTitle: 'activity_type_running',
        iconName: 'icon-activity-trail-running',
        mapMarkerIconName: 'map-marker-course-trail-running',
        parentType: 'running'
    },
    {
        value: 'activity_type_obstacle_run',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'obstacle_run',
        group: 2,
        customGroupTitle: 'activity_type_running',
        iconName: 'icon-activity-obstacle-run',
        mapMarkerIconName: 'map-marker-course-obstacle-run',
        parentType: 'running'
    },
    {
        value: 'activity_type_hiking',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'hiking',
        group: 3,
        customGroupTitle: 'activity_type_hiking',
        iconName: 'icon-activity-hiking',
        mapMarkerIconName: 'map-marker-course-hiking',
        parentType: 'running'
    },
    {
        value: 'activity_type_other',
        postfixValue: 'course_map_filter_options_only',
        typeValue: 'other',
        group: 4,
        customGroupTitle: 'activity_types_more',
        iconName: 'icon-activity-other',
        mapMarkerIconName: 'map-marker-course-other',
        parentType: 'cycling'
    }
];

//same as in LeafletMap utils
export const SupportedPopularityTypes = {
    ROAD_BIKING: 'ROAD_CYCLING',
    ROAD_CYCLING: 'ROAD_CYCLING',
    MOUNTAIN_BIKING: 'MOUNTAIN_BIKING',
    GRAVEL_BIKING: 'GRAVEL_BIKING',
    GRAVEL_CYCLING: 'GRAVEL_BIKING',
    RUNNING: 'RUNNING',
    TRAIL_RUNNING: 'TRAIL_RUNNING',
    HIKING: 'HIKING'
};

//taken form courses/utils/Utils.js - changed to include label
export const DrawingMethodsConst = {
    custom: 'custom',
    roundTrip: 'roundTrip'
};

export const DrawingMethods = [
    {
        label: 'course_map_custom_label',
        optionDetailsLabel: 'create_own_course',
        value: DrawingMethodsConst.custom
    },
    {
        label: 'course_drawing_option_automatic',
        optionDetailsLabel: 'create_automatic_course',
        value: DrawingMethodsConst.roundTrip
    }
];

export const RoutesDrawingTypes = {
    POPULAR_ROUTES: {
        label: 'follow_popular_routes',
        tooltipLabel: 'popularity_routing_tooltip',
        value: 'popular'
    },
    SNAP_TO_ROAD: {
        label: 'course_map_drawing_method_options_follow_roads_and_trails',
        tooltipLabel: 'follow_roads_tooltip',
        value: 'snap'
    },
    FREEHAND: {
        label: 'course_map_drawing_method_options_draw_freehand',
        tooltipLabel: 'freehand_tooltip',
        value: 'free'
    }
};

export const getPrivacyRule = (rulePK) => {
    if (rulePK === RulesDTO.public.id) {
        return RulesDTO.public.key;
    }

    if (rulePK === RulesDTO.private.id) {
        return RulesDTO.private.key;
    }

    return null;
};

export const getActivityTypeIdBasedOnTypeKey = (activityTypes, typeValue) => {
    let value = activityTypes.filter((item) => {
        return item.typeKey === typeValue;
    });

    if (value && value.length) {
        return value[0].typeId;
    }
};

export const getCourseTypeDataBasedOnActivityTypeKey = (activityTypes = [], activityTypePk) => {
    let activityValue = activityTypes.filter((item) => {
        return item.typeId === activityTypePk;
    });

    if (activityValue && activityValue.length) {
        let value = CourseTypes.filter((item) => {
            return item.typeValue === activityValue[0].typeKey;
        });

        if (value && value.length) {
            return value[0];
        }
    }

    return {};
};

/**
 * taken from CourseUtils.js but changed to not handle models
 * @param points
 * @returns {*[]}
 */
export const convertRoundTripRoutesToGeoPointsNoModel = (points) => {
    let geoPoints = [];

    for (let i = 0, len = points.length; i < len; i += 1) {
        let p = points[i].points;
        for (let a = 0, aLen = p.length; a < aLen; a += 1) {
            if (p[a]) {
                geoPoints.push(p[a]);
            }
        }
    }
    return geoPoints;
};

/**
 * parse initial value from the round trip endpoint
 * @param response
 * @returns {*[]}
 */
export const initialParseFromReceiveCourseRoundTripRoute = (response) => {
    let collection = [],
        models = [];

    for (let i = 0, len = response.length; i < len; i += 1) {
        if (response[i]) {
            for (let m = 0, mLen = response[i].length; m < mLen; m += 1) {
                if (response[i][m]) {
                    models.push({
                        latitude: response[i][m][0],
                        longitude: response[i][m][1],
                        distance: null,
                        timestamp: null
                    });
                }
            }
            collection.push({ points: models });
            models = [];
        }
    }

    return collection;
};

export const isRoundTripDrawingSelected = (selectedDrawingMethod) => {
    return selectedDrawingMethod === DrawingMethodsConst.roundTrip;
};

export const isCustomDrawingSelected = (selectedDrawingMethod) => {
    return selectedDrawingMethod === DrawingMethodsConst.custom;
};

export const getMapBounds = (latlngs) => {
    return L.polyline(latlngs).getBounds();
};

export const getShortBounds = (geoPoints) => {
    let setArrayOfLatLon = geoPoints.map((item) => {
        return [item.latitude || item.lat, item.longitude || item.lon];
    });
    let bounds = getMapBounds(setArrayOfLatLon);

    return [bounds.getSouthWest(), bounds.getNorthEast()];
};

export const isCreateFromActivity = () => {
    //same checks as in CourseCreateNewView.js
    return window.location.href.indexOf('create-from-activity') !== -1;
};

export const isCurrentMapProviderOSM = (mapProviderName) => {
    return mapProviderName === Util.MapProviders.OSM;
};

export const getCoordinateSystem = (fromImport) => {
    if (MapUtils.userInChina() || window.location.href.indexOf('chinaMode=true') !== -1) {
        if (isCreateFromActivity() || fromImport) {
            return Util.CoordinateSystem.WGS84;
        } else {
            return Util.CoordinateSystem.BD09;
        }
    } else {
        return Util.CoordinateSystem.WGS84;
    }
};

export const getSourcePk = () => {
    //same checks as in CourseCreateNewView.js
    let index = window.location.pathname.lastIndexOf('/');

    return parseInt(window.location.pathname.substring(index + 1), 10);
};

/**
 * Taken from CourseCreateNew View.js - changed to not use models and collections
 * we have to create one.
 * @param geoPointsArray
 * @returns array
 */
export const getCourseLinesFromGeoPoints = (geoPointsArray) => {
    let points = [],
        courseLines = [],
        totalDistance = 0,
        distance = 0,
        segmentChunkDistanceAllowed = 0,
        p,
        totalDistanceInMeters = 0,
        segmentSize = 6, // We always want 6 segments
        nextPoint;

    // Add distance to the array since import doesn't provide that
    if (geoPointsArray[0].distance === undefined || geoPointsArray[0].distance === null) {
        geoPointsArray = CourseUtil.populateDistanceInGeoPoints(geoPointsArray);
    }

    // Grab the last point since the points in the geoPointsArray contains an acumulative distance
    totalDistanceInMeters = geoPointsArray[geoPointsArray.length - 1].distance;
    segmentChunkDistanceAllowed = totalDistanceInMeters / segmentSize;

    geoPointsArray.forEach((point, index) => {
        nextPoint = geoPointsArray[index + 1];
        p = createCourseLinePoint(point);

        if (nextPoint) {
            distance = CourseUtil.calculateDistanceBetweenPointsInMeters(
                nextPoint.latitude,
                nextPoint.longitude,
                point.latitude,
                point.longitude
            );
            totalDistance += distance;
            distance = totalDistance;
        }

        if (totalDistance >= segmentChunkDistanceAllowed) {
            points.push(p);

            // add a new segment/line
            courseLines.push({
                points: points,
                distanceInMeters: distance // totalDistance for this line (segment)
            });

            //reset
            points = [];
            totalDistance = 0;
        }

        points.push(p);
    });

    if (points.length > 0) {
        // add a new segment/line
        courseLines.push({
            points: points,
            distanceInMeters: totalDistance
        });
    }

    return setExtraDataForEachCourseLine(courseLines);
};

export const setExtraDataForEachCourseLine = (courseLines, courseId = null, fromImport = false) => {
    if (courseLines && courseLines.length) {
        return courseLines.map((line, index) => {
            //distance in meters is already set same for points
            line.courseId = courseId;
            line.sortOrder = index + 1;
            line.numberOfPoints = line.points?.length || 0;
            line.bearing = 0;
            line.coordinateSystem = getCoordinateSystem(fromImport);

            if (line.points?.length) {
                line.distanceInMeters = getLineDistanceFromPoints(line.points);
            }

            return line;
        });
    }
};

/**
 *
 * @param linePoints
 * @returns {number}
 */
export const getLineDistanceFromPoints = (linePoints) => {
    return linePoints[linePoints.length - 1].distance - linePoints[0].distance;
};

/**
 * this is for the payload for the course/routeSegments request - it is much less data for the lines than setExtraDataForEachCourseLine
 * @param courseLines
 * @param courseId
 * @returns {*}
 */
export const getCourseLineDataForRouteSegmentRequest = (courseLines, courseId = null) => {
    if (courseLines && courseLines.length) {
        return courseLines.map((line, index) => {
            return {
                bearing: line.bearing,
                distanceInMeters: line.distanceInMeters,
                numberOfPoints: line.numberOfPoints,
                courseId: courseId,
                sortOrder: line.sortOrder
            };
        });
    }
};

/**
 * Checks if two geo points are the same based on latitude and longitude
 * @param point1
 * @param point2
 * @return {boolean}
 */
export const areGeoPointsEqual = (point1, point2) => {
    return point1.latitude === point2.latitude && point1.longitude === point2.longitude;
};

/**
 * Checks if two geo point arrays are the same based on latitude and longitude of each point
 * @param geoPoints1 {[{latitude: number, longitude: number}]}
 * @param geoPoints2 {[{latitude: number, longitude: number}]}
 * @return {boolean}
 */
export const areGeoPointArraysEqual = (geoPoints1, geoPoints2) => {
    return (
        geoPoints1?.length === geoPoints2?.length &&
        geoPoints1.every((point, index) => areGeoPointsEqual(point, geoPoints2[index]))
    );
};

/**
 * Maps the geoPoints to the format that is used in the elevation request
 * (same format as in the getFormatedData method from the CourseElevations.js file)
 *
 * @param geoPoints {[{latitude: number, longitude: number}]}
 * @return {[number,number,null][]}
 */
export const getFormattedGeoPointsForElevationRequest = (geoPoints) => {
    return geoPoints.map((point) => [point.latitude, point.longitude, null]);
};

/**
 * maps the geoPoints array to the format which is used for the elevation request
 * @param geoPoints
 * @returns {[lat,lon,null][]}
 */
export const parseGeoPointsIntoArraysWithEmptyElevationData = (geoPoints) => {
    let geoPointsParse = initialParseFromReceiveCourseRoundTripRoute(geoPoints);
    let processedGeoPoints = convertRoundTripRoutesToGeoPointsNoModel(geoPointsParse);

    //same format as in the getFormatedData method from the CourseElevations.js file
    return getFormattedGeoPointsForElevationRequest(processedGeoPoints);
};

/**
 * sets the received elevation from endpoint into the existing geoPoints based on a search - same as what was previously implemted in CourseCreateNewView.js
 * @param geoPoints
 * @param arrayOfLatLonElevations
 * @returns {*}
 */
export const setElevationIntoGeoPointsObject = (geoPoints, arrayOfLatLonElevations) => {
    return geoPoints.map((point) => {
        let foundPoint = arrayOfLatLonElevations.find((elevationPoint) => {
            return point.latitude === elevationPoint[0] && point.longitude === elevationPoint[1];
        });
        let returnPoint = { ...point };

        if (foundPoint) {
            returnPoint.elevation = foundPoint[2];
        }

        return { ...returnPoint };
    });
};

/**
 * used to do the same as above but without the find because it is based on index of geoPoint
 * this is only usage is on first request for round trip - because on others it needs to find the exact point
 * @param geoPoints
 * @param arrayOfLatLonElevations
 * @returns {*}
 */
export const setElevationIntoGeoPointsObjectBasedOnIndex = (geoPoints, arrayOfLatLonElevations) => {
    return geoPoints.map((point, index) => {
        let foundPoint = arrayOfLatLonElevations[index];

        if (foundPoint) {
            point.elevation = foundPoint[2];
        }
        return point;
    });
};

/**
 * Used to getthe elevation gained and loss that is displayed in the ui and sent to API - also has methods to get elev gain/loss in range
 * @param processedGeoPoints
 * @returns {{getElevationGain: (ElevationGainAnalyzer.elevationGain|number), getElevationLossForRange: (function(*, *): (*|number)), getElevationLoss: (ElevationLossAnalyzer.elevationLoss|number), getElevationGainForRange: (function(*, *): (*|number))}}
 */
export const getElevationAnalyzer = (processedGeoPoints) => {
    let elevationData = CourseUtil.getElevationDataFromGeoPoints(processedGeoPoints);
    let elevationGainAnalyzer = new ElevationGainAnalyzer(CourseUtil.getElevationGainThreshold());
    let elevationLossAnalyzer = new ElevationLossAnalyzer(CourseUtil.getElevationLossThreshold());

    elevationData.forEach((point, index) => {
        elevationGainAnalyzer.notifyNewPoint(CourseUtil.convertElevationDataForElevationAnalyzer(point));
        elevationLossAnalyzer.notifyNewPoint(CourseUtil.convertElevationDataForElevationAnalyzer(point));
    });

    return {
        getElevationGain: elevationGainAnalyzer.getValue(),
        getElevationLoss: elevationLossAnalyzer.getValue(),
        getElevationGainForRange: elevationGainAnalyzer.getElevationGainForRange,
        getElevationLossForRange: elevationLossAnalyzer.getElevationLossForRange
    };
};

/**
 * used to process data for the store based on the received geoPoints from API
 * @param geoPoints
 * @param previousSetPoints
 * @returns {{geoPoints: ({length}|*), boundingBox: {lowerLeft: {latitude: *, longitude: *}, lowerLeftLongIsSet: boolean, upperRightLatIsSet: boolean, upperRightLongIsSet: boolean, upperRight: {latitude: *, longitude: *}, lowerLeftLatIsSet: boolean}, startPoint: (*|null), distanceMeter: *}}
 */
export const getProcessedDataFromGeoPoints = (geoPoints, previousSetPoints = []) => {
    let geoPointsParse = initialParseFromReceiveCourseRoundTripRoute(geoPoints);
    let temporaryProcessedGeoPoints = convertRoundTripRoutesToGeoPointsNoModel(geoPointsParse);
    let processedGeoPoints;

    if (previousSetPoints && previousSetPoints.length > 0) {
        //if previous points were added then prepend those points
        processedGeoPoints = [...previousSetPoints, ...temporaryProcessedGeoPoints];
    } else {
        processedGeoPoints = [...temporaryProcessedGeoPoints];
    }

    //add distance values and strip dups
    CourseUtil.populateDistanceInGeoPoints(processedGeoPoints);
    stripDupDistancesFromPoints(processedGeoPoints, 'distance');

    return getPointsChangedObject(processedGeoPoints);
};

/**
 * used to return consistent data if the geopoints are changed
 * if return object is modified this one needs to update getInitialObjectForHistoryFromCourseData as well - and vice versa
 * @param geoPoints
 * @param {boolean} [undo] function is called with "undo" action, we used previous distance if exist
 * @returns {{geoPoints: ({length}|*), boundingBox: {lowerLeft: {latitude: *, longitude: *}, lowerLeftLongIsSet: boolean, upperRightLatIsSet: boolean, upperRightLongIsSet: boolean, upperRight: {latitude: *, longitude: *}, lowerLeftLatIsSet: boolean}, startPoint: (*|null), distanceMeter: *}}
 */
export const getPointsChangedObject = (geoPoints, undo = false) => {
    if (geoPoints && geoPoints.length) {
        let elevationAnalyzerData = getElevationAnalyzer(geoPoints);
        let endPoint = geoPoints && geoPoints.length ? geoPoints[geoPoints.length - 1] : null;

        let setArrayOfLatLon = geoPoints.map((item) => {
            return [item.latitude, item.longitude];
        });
        let bounds = getMapBounds(setArrayOfLatLon);
        let southWest = bounds.getSouthWest();
        let northEast = bounds.getNorthEast();

        let changedObj = {
            startPoint: geoPoints && geoPoints.length ? geoPoints[0] : null,
            geoPoints: geoPoints,
            boundingBox: {
                lowerLeft: {
                    latitude: southWest && southWest.lat,
                    longitude: southWest && southWest.lng
                },
                upperRight: {
                    latitude: northEast && northEast.lat,
                    longitude: northEast && northEast.lng
                },
                lowerLeftLatIsSet: true,
                lowerLeftLongIsSet: true,
                upperRightLatIsSet: true,
                upperRightLongIsSet: true
            }
        };

        if (endPoint && endPoint.distance && !undo && !changedObj.distanceMeter) {
            changedObj.distanceMeter = endPoint.distance;
        }

        if (
            elevationAnalyzerData &&
            !isNaN(elevationAnalyzerData.getElevationGain) &&
            !isNaN(elevationAnalyzerData.getElevationLoss)
        ) {
            changedObj.elevationGainMeter = elevationAnalyzerData.getElevationGain;
            changedObj.elevationLossMeter = elevationAnalyzerData.getElevationLoss;
        }

        return changedObj;
    }

    return getInitialObjectForHistoryFromCourseData();
};

/**
 * creates the course lines from the geoPoints and the existing course lines
 * the course line creation is not dependent on the elevation data
 * @param isRoundTrip - this means that all the points are known initially
 * @param newCoursePoints
 * @param courseData
 * @param {boolean} [fromImport] indicating action is trigger from import, so coordinate system will remain "WGS84"
 * @returns {*}
 */
export const setCourseLines = (isRoundTrip = false, newCoursePoints, courseData, fromImport = false) => {
    const { courseLines, courseId } = courseData;

    if (isRoundTrip) {
        // for roundTrip the courseLines need to be calculated and added - completely
        let availableCourseLines =
            newCoursePoints && newCoursePoints.length ? getCourseLinesFromGeoPoints(newCoursePoints) : [];

        return setExtraDataForEachCourseLine(availableCourseLines, courseId, fromImport);
    }

    // if there are no new points return the existing course lines
    if (!newCoursePoints || !newCoursePoints.length) {
        return courseLines;
    }

    //if it's the first line to be created
    if (!courseLines.length) {
        //distance in this case is the total distance - no need to calculate segment distance
        let line = {
            distanceInMeters: newCoursePoints[newCoursePoints.length - 1].distance,
            points: newCoursePoints.map((item) => createCourseLinePoint(item))
        };
        return setExtraDataForEachCourseLine([line], courseId, fromImport);
    }

    //calculate the distance of the new segment/line
    let lineDistance = getLineDistanceFromPoints(newCoursePoints);
    //set the proper points values
    let points = newCoursePoints.map((item) => createCourseLinePoint(item));

    return setExtraDataForEachCourseLine(
        [
            ...courseLines,
            {
                distanceInMeters: lineDistance,
                points: points
            }
        ],
        courseId,
        fromImport
    );
};

const getElevationHashMapKey = (point) => {
    if (!point) return '';

    if (point.latitude && point.longitude) {
        return `${point.latitude}_${point.longitude}`;
    }

    if (point.lat && point.lon) {
        return `${point.lat}_${point.lon}`;
    }

    return '';
};

const getGeoPointElevationHashMap = (geoPoints) => {
    return geoPoints.reduce((acc, point) => {
        acc[getElevationHashMapKey(point)] = point.elevation;
        return acc;
    }, {});
};

export const updateExistingCourseLinesWithElevation = (courseLines, geoPointsWithElevation) => {
    // if there is nothing to update return the course lines
    if (!courseLines || !courseLines.length || !geoPointsWithElevation || !geoPointsWithElevation.length) {
        return courseLines;
    }

    // it is created to have an optimized way to update the course lines with the elevation data
    const elevationHashMap = getGeoPointElevationHashMap(geoPointsWithElevation);

    // creates a deep copy of the course lines
    const courseLinesCopy = JSON.parse(JSON.stringify(courseLines));

    courseLinesCopy.forEach((line) => {
        line.points = line.points?.map((point) => {
            const foundElevation = elevationHashMap[getElevationHashMapKey(point)];

            if (foundElevation) {
                point.elevation = foundElevation;
            }

            return point;
        });
    });

    return courseLinesCopy;
};

/**
 * used to alter the courseLines/segments with the added point at the mentioned index - increase line length when adding point on course
 * @param initialCourseLines
 * @param newPointToAdd
 * @param initialItemAtIndex
 */
export const incrementCourseLinesWithAddedPoint = (initialCourseLines, newPointToAdd, initialItemAtIndex) => {
    if (initialCourseLines && initialCourseLines.length && newPointToAdd) {
        let courseLines = [...initialCourseLines].map((a) => {
            return { ...a };
        });

        //keep in mind that courseLines end and start with the same point -
        //so there are duplicates and because of that there are more with the line length than the geoPoints
        courseLines.find((line) => {
            if (line && line.points && line.points.length) {
                return line.points.find((point, pointIndex) => {
                    if (point.lat === initialItemAtIndex.latitude && point.lon === initialItemAtIndex.longitude) {
                        const pointToAdd = createCourseLinePoint(newPointToAdd);

                        line.numberOfPoints = line.numberOfPoints + 1;
                        line.points.splice(pointIndex, 0, pointToAdd);

                        return point;
                    }
                });
            }
        });

        return courseLines;
    }

    return initialCourseLines;
};

/**
 * used to standardize the object for the course line point
 * @param point
 * @returns {{elevation, lon, lat, timestamp, distance}}
 */
export const createCourseLinePoint = (point) => {
    let linePointObject = {
        lon: point.longitude,
        lat: point.latitude,
        timestamp: point.timestamp,
        elevation: point.elevation,
        distance: point.distance
    };

    if (point.tempId) {
        linePointObject.tempId = point.tempId;
    }

    return linePointObject;
};

/**
 * used to standardize the object for the course line point
 * @param point
 * @returns {{elevation, longitude, latitude, timestamp, distance}}
 */
export const createCourseGeoPointFromLinePoint = (point) => {
    return {
        longitude: point.lon,
        latitude: point.lat,
        timestamp: point.timestamp,
        elevation: point.elevation,
        distance: point.distance
    };
};

/**
 * This function is used for initial setup of history object - no processing used - if return object from getPointsChangedObject is modified this one needs to update as well
 * @param courseData
 * @returns {{geoPoints: ([]|[{latitude: *, longitude: {latlng}|*}]|*), boundingBox: (null|*), elevationLossMeter: (null|*), startPoint, distanceMeter: (null|*), elevationGainMeter: (null|*), elapsedSeconds}}
 */
export const getInitialObjectForHistoryFromCourseData = (courseData = false) => {
    if (typeof courseData === 'object') {
        return {
            startPoint: courseData.startPoint,
            distanceMeter: courseData.distanceMeter,
            geoPoints: courseData.geoPoints,
            courseLines: courseData.courseLines,
            boundingBox: courseData.boundingBox,
            elevationGainMeter: courseData.elevationGainMeter,
            elevationLossMeter: courseData.elevationLossMeter,
            coursePoints: courseData.coursePoints,
            climbsOnRouteOrCourse: []
        };
    } else {
        return {
            startPoint: null,
            distanceMeter: null,
            geoPoints: [],
            courseLines: [],
            boundingBox: null,
            elevationGainMeter: null,
            elevationLossMeter: null,
            coursePoints: null,
            climbsOnRouteOrCourse: []
        };
    }
};

/**
 * same check as in CourseCreateNewView.js
 * @param editableCourseDetails
 * @param profileId
 * @param groupMember
 * @returns {boolean}
 */
export const isViewerOwner = (editableCourseDetails, profileId, groupMember) => {
    let userProfilePk = editableCourseDetails ? editableCourseDetails.userProfilePk : null;
    let isOwner = false;

    if (userProfilePk) {
        isOwner = profileId === userProfilePk;
    }

    if (!isOwner && groupMember) {
        isOwner = groupMember.groupRole === GroupRoleTypes.ADMIN;
    }
    return isOwner;
};

/**
 * Should the Course support Climbs
 * @param activityTypes
 * @param editableCourseDetails
 * @returns {boolean}
 */

export const isClimbsCourseType = (activityTypes, editableCourseDetails) => {
    const { activityTypePk } = editableCourseDetails;
    return isCyclingParentActivityTypeExcludingOther(activityTypes, activityTypePk);
};

/**
 * used to detect if the given activityTypePk is for a cycling parent activity type excluding other
 * @param activityTypes
 * @param activityTypePk
 * @returns {boolean}
 */
export const isCyclingParentActivityTypeExcludingOther = (activityTypes, activityTypePk) => {
    const courseType = getCourseTypeDataBasedOnActivityTypeKey(activityTypes, activityTypePk);

    //if set to cycling reset the hasTurnDetectionDisabled
    const courseTypeValue = courseType && courseType.typeValue;

    return courseType && courseType.parentType === 'cycling' && courseTypeValue !== 'other';
};

/**
 *
 * @param {string} property
 * @returns
 */
function getCssStyle(property) {
    return window.getComputedStyle(document.body, null).getPropertyValue(property);
}

let textWidthCalcCanvas = null;

/**
 *
 * @param {string} text
 * @returns
 */
function measureTextWidth(text) {
    if (!textWidthCalcCanvas) {
        textWidthCalcCanvas = document.createElement('canvas');
        const fontWeight = getCssStyle('font-weight') || 'normal';
        const fontSize = getCssStyle('font-size') || '14px';
        const fontFamily = getCssStyle('font-family') || 'sans-serif';
        textWidthCalcCanvas.getContext('2d').font = `${fontWeight} ${fontSize} ${fontFamily}`;
    }
    const context = textWidthCalcCanvas.getContext('2d');
    const metrics = context.measureText(text);
    return metrics.width;
}

/**
 * used to dinamicaly set the width of the input field so it will not take the with of the longest available option - with one icon padding
 * @param text
 * @param {number} [padding] extra padding
 * @returns {string}
 */
export const getFieldWidthWithAnIcon = (text, padding = 0) => {
    if (text && text.length) {
        const textWidth = measureTextWidth(text);
        return padding + 16 + textWidth + 'px';
    }
    return 'auto';
};

/**
 * used to dinamicaly set the width of the input field so it will not take the with of the longest available option - with two icons padding
 * @param text
 * @param {number} [padding] extra padding
 * @returns {string}
 */
export const getFieldWidthWithTwoIcons = (text, padding = 0) => {
    if (text && text.length) {
        const textWidth = measureTextWidth(text);
        return padding + 32 + textWidth + 'px';
    }
    return 'auto';
};

/**
 * returns a new course geopoints history array
 * @param nextIndex
 * @param currentCourseRouteHistory
 * @param updatedDataFromGeoPoints
 * @param coursePoints
 * @param courseLines
 * @param {boolean} [removeHistoryAfterNextIndex] in case only the elevation is updated we don't want to remove the history
 * @param {boolean} [undo] function is called with "undo" action, we used previous distance if exist
 * @returns {*}
 */
export const getNextCourseRouteHistory = (
    nextIndex,
    currentCourseRouteHistory,
    updatedDataFromGeoPoints,
    coursePoints,
    courseLines,
    removeHistoryAfterNextIndex = true,
    undo = false
) => {
    let nextCourseRouteHistory = {
        ...currentCourseRouteHistory
    };

    let undoData;
    if (undo) {
        undoData = nextCourseRouteHistory[nextIndex];
    }

    nextCourseRouteHistory[nextIndex] = { ...getInitialObjectForHistoryFromCourseData(undoData) };

    if (updatedDataFromGeoPoints) {
        nextCourseRouteHistory[nextIndex] = {
            ...nextCourseRouteHistory[nextIndex],
            ...updatedDataFromGeoPoints
        };
    }
    //course points are only added by a user input button and not via request
    if (coursePoints) {
        nextCourseRouteHistory[nextIndex].coursePoints = [...coursePoints];
    }

    //course lines
    if (courseLines) {
        nextCourseRouteHistory[nextIndex].courseLines = [...courseLines];
    }

    if (removeHistoryAfterNextIndex) {
        //must also remove all currentCourseRouteHistory arrays after the index because on change there is no more redo options
        const keysToBeRemoved = Object.keys(currentCourseRouteHistory).filter((item) => item > nextIndex);

        //if the array of found items over the currently incremented key has items it will remove them otherwise it will not do the forEach
        keysToBeRemoved.forEach((key) => {
            delete nextCourseRouteHistory[key];
        });
    }

    return nextCourseRouteHistory;
};

/**
 * updates the course route history with climbs on route
 * @param historyIndex
 * @param currentCourseRouteHistory
 * @param climbsOnRouteOrCourse
 * @returns {*}
 */
export const updateCourseRouteHistoryWithWithClimbsOnRoute = (
    historyIndex,
    currentCourseRouteHistory,
    climbsOnRouteOrCourse
) => {
    let nextCourseRouteHistory = {
        ...currentCourseRouteHistory
    };

    nextCourseRouteHistory[historyIndex] = {
        ...nextCourseRouteHistory[historyIndex],
        climbsOnRouteOrCourse
    };

    return nextCourseRouteHistory;
};

/**
 * get the maximum value from the data array of objects for the elevation of distance key
 * @param data
 * @param isElevation
 * @param getMinimumValue
 * @returns {*}
 */
export const getMaxOrMinValueForKey = (data, isElevation = false, getMinimumValue = false) => {
    if (data) {
        let key = isElevation ? CHART_AXIS_VALUES.Y : CHART_AXIS_VALUES.X;
        let returnValue;

        if (getMinimumValue) {
            returnValue = data.reduce((prev, curr) => (prev[key] < curr[key] ? prev : curr));
        } else {
            returnValue = data.reduce((prev, curr) => (prev[key] > curr[key] ? prev : curr));
        }

        return returnValue[key];
    }
};

/**
 * set an array of ticks based on the data, the axis (elevation is y Axis) and if is a large chart to set more ticks on the X Axis (distance)
 * @param data
 * @param isElevation
 * @param isLargeChart
 * @param elevationPadding
 * @returns {*[]}
 */
export const generateTicks = (data, isElevation = false, isLargeChart = false, elevationPadding = 0) => {
    let ticks = [];
    let minValue = getMaxOrMinValueForKey(data, isElevation, true) - elevationPadding;
    let maxValue = getMaxOrMinValueForKey(data, isElevation) + elevationPadding;
    const minElevationCheck = 200;

    if (isElevation && elevationPadding) {
        if (maxValue - minValue < minElevationCheck) {
            maxValue = minValue + minElevationCheck;
        }
    }

    if (!isNaN(minValue) && !isNaN(maxValue)) {
        let valueToDivideBy = isLargeChart && !isElevation ? 9 : 3;
        let calcValue = (maxValue - minValue) / valueToDivideBy;

        if (isElevation) {
            //elevation is for y Axis - it has just 4 items
            ticks.push(parseInt(minValue, 10));
            ticks.push(parseInt(minValue + Math.floor(calcValue), 10));
            ticks.push(parseInt(maxValue - Math.floor(calcValue), 10));
            ticks.push(parseInt(maxValue, 10));
        } else {
            //distance is for x Axis - it may have 4 or more ticks depending on chart width
            ticks.push(minValue);
            let currentValueToAdd = Math.floor(calcValue);

            for (let i = 1; i < valueToDivideBy; i++) {
                ticks.push(minValue + currentValueToAdd);
                currentValueToAdd += Math.floor(calcValue);
            }
            ticks.push(maxValue);
        }
    }

    return ticks;
};

/**
 *
 * @param courseLines
 * @returns {*}
 */
export const reverseDirection = (courseLines) => {
    let reversedArrayOfLines = courseLines.slice().reverse();
    let cumulativeDistance = 0;

    reversedArrayOfLines = reversedArrayOfLines.map((item, index) => {
        let newSortOrder = index + 1;
        let reversedPoints = [...item.points].slice().reverse();

        item = {
            ...item,
            sortOrder: newSortOrder,
            points: incrementDistanceBetweenPoints(reversedPoints, cumulativeDistance)
        };

        cumulativeDistance = item.points[item.points.length - 1].distance;
        return item;
    });

    return reversedArrayOfLines;
};

/**
 *
 * @param courseLines
 * @returns {(*&{sortOrder: number})[]}
 */
export const outAndBackLines = (courseLines = []) => {
    let reversedArrayOfLines = reverseDirection(courseLines);

    //remove all coursePoint markers reference so the deletion/drag of start end will not reference that marker
    reversedArrayOfLines.forEach((singleLine) => {
        if (singleLine.points && singleLine.points.length) {
            singleLine.points.forEach((linePoint) => {
                linePoint.timestamp = null;
                linePoint.coursePointId = null;
            });
        }
    });

    let currentCourseLines = [...courseLines, ...reversedArrayOfLines];
    let cumulativeDistance;

    currentCourseLines = currentCourseLines.map((item, index) => {
        let setItem = {
            ...item,
            sortOrder: index + 1
        };
        //if last line in initially received CourseLines - get the last points distance to start cumulating the distance
        if (
            setItem.sortOrder === courseLines[courseLines.length - 1].sortOrder &&
            courseLines[courseLines.length - 1].points.length
        ) {
            cumulativeDistance = item.points[item.points.length - 1].distance;
        } else if (cumulativeDistance) {
            setItem.points = incrementDistanceBetweenPoints(item.points, cumulativeDistance);
            cumulativeDistance = setItem.points[setItem.points.length - 1].distance;
        }

        return setItem;
    });

    return currentCourseLines;
};

/**
 *
 * @param points
 * @param cumulativeDistance
 * @returns {*}
 */
export const incrementDistanceBetweenPoints = (points, cumulativeDistance = 0) => {
    let initialCumulativeDistance = cumulativeDistance;

    return points.map((point, index) => {
        const nextPoint = points[index + 1];

        let returnObject = {
            ...point,
            timestamp: null,
            distance: initialCumulativeDistance
        };

        if (nextPoint) {
            let distanceBetweenPoints = CourseUtil.calculateDistanceBetweenPointsInMeters(
                point.lat,
                point.lon,
                nextPoint.lat,
                nextPoint.lon
            );
            initialCumulativeDistance += distanceBetweenPoints;
        }

        return returnObject;
    });
};

export const getMapSetting = (mapSettings, setting) => {
    const parsedMapSettings = typeof mapSettings === 'string' ? JSON.parse(mapSettings) : mapSettings;

    return parsedMapSettings ? parsedMapSettings[setting] : null;
};

/**
 *
 * @param mapProvider
 * @param mapSettings
 * @returns {string}
 */
export const getMapType = (mapProvider, mapSettings) => {
    let parsedMapType = typeof mapSettings === 'string' ? JSON.parse(mapSettings) : mapSettings;
    let type = null;

    switch (mapProvider) {
        case mapProviderInfo.here.value:
            type = hereMapViewType(parsedMapType);
            break;
        case mapProviderInfo.osm.value:
            type = mapProviderInfo.osm.value;
            break;
        case mapProviderInfo.google.value:
            type = googleMapType(parsedMapType);
            break;
        case mapProviderInfo.baidu.value:
            type = baiduMapType(parsedMapType);
            break;
        default:
            if (isChinaUser()) {
                type = baiduMapType(parsedMapType);
            } else {
                type = googleMapType(parsedMapType);
            }
            break;
    }
    return type;
};

export const hereMapViewType = (mapSettingsJSON) => {
    if (mapSettingsJSON && (mapSettingsJSON.satellite || mapSettingsJSON.hybrid)) {
        /**
         * the hybrid map layer allows for trails to display on top + it shows the labels on the map - satellite does not
         * if we want to switch between hybrid and satellite
         * check for mapSettingsJSON.trails to return mapProviderInfo.google.types.hybrid else return mapProviderInfo.google.types.satellite;
         */
        return 'hybrid';
    } else {
        return 'normal';
    }
};

export const googleMapType = (mapSettingsJSON) => {
    if (mapSettingsJSON && (mapSettingsJSON.satellite || mapSettingsJSON.hybrid)) {
        /**
         * the hybrid map layer allows for trails to display on top + it shows the labels on the map - satellite does not
         * if we want to switch between hybrid and satellite
         * check for mapSettingsJSON.trails to return mapProviderInfo.google.types.hybrid else return mapProviderInfo.google.types.satellite;
         */
        return mapProviderInfo.google.types.hybrid;
    } else if (mapSettingsJSON && mapSettingsJSON.terrain) {
        return mapProviderInfo.google.types.terrain;
    } else {
        return mapProviderInfo.google.types.default;
    }
};

export const baiduMapType = (mapSettingsJSON) => {
    if (mapSettingsJSON && (mapSettingsJSON.satellite || mapSettingsJSON.hybrid)) {
        /**
         * this method apply to `GarminTileLayer`, that accept `satellite` instead of `SATELLITE.Map`
         */
        return 'satellite';
    } else {
        return mapProviderInfo.baidu.type.default;
    }
};

/**
 * receive zoom limits based on map provider
 * @param mapProvider
 * @returns {{maxZoom: number, minZoom: number}}
 */
export const getZoomLimits = (mapProvider) => {
    switch (mapProvider) {
        case mapProviderInfo.here.value:
            return {
                maxZoom: mapProviderInfo.here.options.maxZoom,
                minZoom: mapProviderInfo.here.options.minZoom
            };
        case mapProviderInfo.osm.value:
            return {
                maxZoom: mapProviderInfo.osm.options.maxZoom,
                minZoom: mapProviderInfo.osm.options.minZoom
            };
        case mapProviderInfo.google.value:
            return {
                maxZoom: mapProviderInfo.google.options.maxZoom,
                minZoom: mapProviderInfo.google.options.minZoom
            };
        case mapProviderInfo.baidu.value:
            return {
                maxZoom: mapProviderInfo.baidu.options.maxZoom,
                minZoom: mapProviderInfo.baidu.options.minZoom
            };
        default:
            return {
                maxZoom: 17,
                minZoom: 3
            };
    }
};

/**
 *
 * @param hasInitialLocation
 * @param callback
 * @returns {{length}|*|void}
 */
export const userCurrentLocation = (hasInitialLocation, callback = () => {}) => {
    if (hasInitialLocation && hasInitialLocation.length) {
        //if has initial location - array of lat and lon
        if (typeof callback === 'function') {
            callback(hasInitialLocation);
        }

        return hasInitialLocation;
    } else {
        //if center location is not set by the course data get user current location or go to default
        return GeolocationUtil.getCurrentPosition(
            (position) => {
                const coords = [position.coords.latitude, position.coords.longitude];

                if (typeof callback === 'function') {
                    callback(coords);
                }

                return coords;
            },
            () => {
                if (typeof callback === 'function') {
                    callback(DEFAULT_USER_LOCATION);
                }

                return DEFAULT_USER_LOCATION;
            }
        );
    }
};

/**
 *
 * @param availableCoursePoints
 * @param coursePointType
 * @param getHoverImage
 * @returns {string|*}
 */
export const getIconUrl = (availableCoursePoints, coursePointType, getHoverImage = false) => {
    const iconOptions =
        coursePointType &&
        availableCoursePoints &&
        availableCoursePoints.CourseMapDefaultOptions &&
        availableCoursePoints.CourseMapDefaultOptions.CoursePointIDMap[coursePointType] &&
        availableCoursePoints.CourseMapDefaultOptions.CoursePointIDMap[coursePointType].iconOptions;

    if (iconOptions) {
        if (getHoverImage) {
            return iconOptions.iconHoverUrl;
        }
        return iconOptions.iconUrl;
    } else {
        //fallback - multiple coursePointType will not be available for 3rd party courses
        if (getHoverImage) {
            return genericPointMarkerHoverUrl;
        }
        return genericPointMarkerUrl;
    }
};

/**
 *
 * @param availableCoursePoints
 * @param coursePointType
 * @returns {string|*}
 */
export const getIconTextKey = (availableCoursePoints, coursePointType) => {
    const iconCoursePointData =
        coursePointType &&
        availableCoursePoints &&
        availableCoursePoints.CourseMapDefaultOptions &&
        availableCoursePoints.CourseMapDefaultOptions.CoursePointIDMap[coursePointType];

    if (iconCoursePointData) {
        return iconCoursePointData.key;
    }

    return '';
};

/**
 * Used to get the Key for the name to use in the ui-connect Icon component
 * @param availableCoursePoints
 * @param coursePointType
 * @returns {string|*}
 */
export const getIconComponentNameKey = (availableCoursePoints, coursePointType) => {
    const iconCoursePointData = availableCoursePoints?.CourseMapDefaultOptions?.CoursePointIDMap?.[coursePointType];

    if (iconCoursePointData) {
        return iconCoursePointData.iconComponentName;
    }

    return '';
};

/**
 * Route received or created might have up to 2km of missing points so mile markers are incorrectly set with some even being stacked
 * For freehand a route, no mather how large, could have only two points, so the extra points are needed to set the mile markers
 * For popularity routing or follow roads the points are usually clustered and there are a lot of distance between some points so this is still needed to set extra points.
 * @param route - needs to be an array
 * @param distanceBetweenPoints - number at witch set extra points in route
 * @returns {*[]} new route with more points
 */
export const setPointsInRoute = (route, distanceBetweenPoints = 0.1) => {
    let newRoute = [...route];
    //default distance to check for is 100 meters if no param is provided
    let allowedDistanceBetweenPoints =
        distanceBetweenPoints && !isNaN(distanceBetweenPoints) ? distanceBetweenPoints : 0.1;

    if (route && route.length >= 2) {
        for (let j = 0; j < newRoute.length - 1; j++) {
            let start = newRoute[j];
            let end = newRoute[j + 1];
            if (start && end) {
                let firstPointDistance = MapUtil.calculateDistanceBetweenPointsInMeters(
                    start.lat,
                    start.lng,
                    end.lat,
                    end.lng
                );

                if (firstPointDistance > allowedDistanceBetweenPoints) {
                    let bearing = MapUtil.calculateBearingOfPoints(start, end);
                    let destinationPoint = MapUtil.calculateDestinationPoint(
                        start,
                        allowedDistanceBetweenPoints,
                        bearing
                    );

                    if (destinationPoint && destinationPoint.lat && destinationPoint.lng) {
                        //if new point is available then set it else skip to next point
                        let newPoint = L.latLng(destinationPoint.lat, destinationPoint.lng);

                        if (!isNaN(start.parentIndex)) {
                            //if parent index is set then childShould reflect the intial points index
                            newPoint.parentIndex = start.parentIndex;
                        }
                        newRoute.splice(j + 1, 0, newPoint);
                    }
                }
            }
        }
    }

    return newRoute;
};

/**
 * same as setPointsInRoute - but different format of coordinates and simplified
 * Route received or created might have up to 2km of missing points so mile markers are incorrectly set with some even being stacked
 * For freehand a route, no mather how large, could have only two points, so the extra points are needed to set the mile markers
 * For popularity routing or follow roads the points are usually clustered and there are a lot of distance between some points so this is still needed to set extra points.
 * @param route - needs to be an array
 * @param distanceBetweenPoints - number at witch set extra points in route
 * @returns {*[]} new route with more points
 */
export const setPointsInRouteWithLongFormat = (route, distanceBetweenPoints = 100) => {
    let newRoute = [...route];
    //default distance to check for is 100 meters if no param is provided
    let allowedDistanceBetweenPoints =
        distanceBetweenPoints && !isNaN(distanceBetweenPoints) ? distanceBetweenPoints : 100;

    if (newRoute && newRoute.length >= 2) {
        for (let j = 0; j < newRoute.length - 1; j++) {
            let start = {
                lat: newRoute[j].latitude,
                lng: newRoute[j].longitude
            };
            let end = {
                lat: newRoute[j + 1].latitude,
                lng: newRoute[j + 1].longitude
            };
            if (start && end) {
                let firstPointDistance = MapUtil.calculateDistanceBetweenPointsInMeters(
                    start.lat,
                    start.lng,
                    end.lat,
                    end.lng
                );

                if (firstPointDistance > allowedDistanceBetweenPoints) {
                    let bearing = MapUtil.calculateBearingOfPoints(start, end);
                    let destinationPoint = MapUtil.calculateDestinationPoint(
                        start,
                        allowedDistanceBetweenPoints,
                        bearing
                    );

                    if (destinationPoint && destinationPoint.lat && destinationPoint.lng) {
                        //if new point is available then set it else skip to next point
                        let newPoint = L.latLng(destinationPoint.lat, destinationPoint.lng);
                        newRoute.splice(j + 1, 0, {
                            ...newPoint,
                            latitude: newPoint.lat,
                            longitude: newPoint.lng
                        });
                    }
                }
            }
        }
    }

    return newRoute;
};

/**
 * same as setPointsInRoute - but different format of coordinates and simplified
 * Route received or created might have up to 2km of missing points so mile markers are incorrectly set with some even being stacked
 * For freehand a route, no mather how large, could have only two points, so the extra points are needed to set the mile markers
 * For popularity routing or follow roads the points are usually clustered and there are a lot of distance between some points so this is still needed to set extra points.
 * @param route - needs to be an array
 * @param distanceBetweenPoints - number at witch set extra points in route
 * @param maxDistanceBetweenPointsAllowed - we have a 10km threshold for inserting points - if it is over 10km do not insert points
 * @returns {*[]} new route with more points
 */
export const setPointsInRouteWithArrayFormat = (
    route,
    distanceBetweenPoints = 100,
    maxDistanceBetweenPointsAllowed = 10000
) => {
    let newRoute = [...route];

    //default distance to check for is 100 meters if no param is provided
    let allowedDistanceBetweenPoints =
        distanceBetweenPoints && !isNaN(distanceBetweenPoints) ? distanceBetweenPoints : 100;

    if (newRoute && newRoute.length >= 2) {
        let givenMaxDistanceBetweenPoints = CourseUtil.calculateDistanceBetweenPointsInMeters(
            newRoute[0][0],
            newRoute[0][1],
            newRoute[newRoute.length - 1][0],
            newRoute[newRoute.length - 1][1]
        );

        if (givenMaxDistanceBetweenPoints < maxDistanceBetweenPointsAllowed) {
            for (let j = 0; j < newRoute.length - 1; j++) {
                let start = {
                    lat: newRoute[j][0],
                    lng: newRoute[j][1]
                };
                let end = {
                    lat: newRoute[j + 1][0],
                    lng: newRoute[j + 1][1]
                };
                if (start && end) {
                    let firstPointDistance = MapUtil.calculateDistanceBetweenPointsInMeters(
                        start.lat,
                        start.lng,
                        end.lat,
                        end.lng
                    );

                    if (firstPointDistance > allowedDistanceBetweenPoints) {
                        let bearing = MapUtil.calculateBearingOfPoints(start, end);
                        let destinationPoint = MapUtil.calculateDestinationPoint(
                            start,
                            allowedDistanceBetweenPoints,
                            bearing
                        );

                        if (destinationPoint && destinationPoint.lat && destinationPoint.lng) {
                            //if new point is available then set it else skip to next point
                            let newPoint = L.latLng(destinationPoint.lat, destinationPoint.lng);
                            newRoute.splice(j + 1, 0, [newPoint.lat, newPoint.lng, null]);
                        }
                    }
                }
            }
        }
    }

    return newRoute;
};

/**
 * Returns a point on the polyline made up of latLngs closest to the latlng passed in
 *
 * same method as mapUtil.findPointOnPolyline from MapUtil.js - just start and end equals check changed
 *
 * @param latLngs: array of Leaflet latLngs that represent a polyline
 * @param latlng
 * @param index: the index of the closest lat,lng point in latLngs to latlng. Found using mapUtil.indexOfClosestPoint
 * @param zoom
 * @return Leaflet LatLng corresponding to the closest point on the polyline to the latlng passed in
 */
export const findPointOnPolyline = (latLngs, latlng, index, zoom) => {
    const crs = MapUtils.userInChina() ? L.CRS.BEPSG3857 : L.CRS.Simple;
    let polylinePoint,
        polylineLatLng,
        start = latLngs[index - 1],
        end = latLngs[index],
        //convert start, end, latlng to x,y values
        x1 = crs.latLngToPoint(start, zoom).x, //lon
        y1 = crs.latLngToPoint(start, zoom).y, //lat
        x2 = crs.latLngToPoint(end, zoom).x, //lon
        y2 = crs.latLngToPoint(end, zoom).y, //lat
        px = crs.latLngToPoint(latlng, zoom).x, //lon
        py = crs.latLngToPoint(latlng, zoom).y, //lat
        //dot product of vector from start to p and vector from start to end divided by squared magnitude of vector from start to end
        t = ((px - x1) * (x2 - x1) + (py - y1) * (y2 - y1)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)); //normalized distance of start to closest point on line

    if (t > 1.0) {
        polylineLatLng = { ...end };
        polylineLatLng.parentIndex = start.parentIndex;
    } else if (t < 0.0) {
        polylineLatLng = { ...start };
    } else {
        polylinePoint = {
            x: x1 + t * (x2 - x1),
            y: y1 + t * (y2 - y1)
        };
        //convert polylinePoint to polylineLatLng
        polylineLatLng = crs.pointToLatLng(polylinePoint, zoom);
        polylineLatLng.parentIndex = start.parentIndex;
    }

    return polylineLatLng;
};

/**
 * this method is used to generate additional point on polyLine to return one closest to clicked point
 * @param smallArray
 * @param clickedPoint
 * @param zoomLevel
 * @returns {*}
 */
export const getClosestPointOnPolyLineToClicked = (smallArray, clickedPoint, zoomLevel = 10) => {
    let lastParentIndex = smallArray[smallArray.length - 1].parentIndex;
    let longRoute = [...smallArray];
    //increase the number of point - with a reference to original parent point - so it can be found based on coordinates
    longRoute = setPointsInRoute(longRoute, 1);
    let indexOfLatLngForDetailedRoute = MapUtil.indexOfClosestPoint(longRoute, clickedPoint.latlng, 14); //initial fidelity
    let pointFound = findPointOnPolyline(longRoute, clickedPoint.latlng, indexOfLatLngForDetailedRoute, zoomLevel);

    /**
     * parent point set is actually the index that will require/allow the placement of a new point -
     * so it needs to be incremented by one - except if it is the last point
     */
    //if received parent index is the last item do not increase the index - it will try and attach after the last point
    if (pointFound.parentIndex < lastParentIndex) {
        pointFound.parentIndex = pointFound.parentIndex + 1;
    }

    return pointFound;
};

/**
 *
 * @param linePoints
 * @param clickedPoint
 * @param zoomLevel
 * @param courseLine
 * @returns {*}
 */
export const onPolyLineClickAddCustomCoursePointAtIndexAndCoordinates = (
    linePoints,
    clickedPoint,
    zoomLevel,
    courseLine = false
) => {
    let smallArray = [...linePoints].map((item, index) => {
        if (courseLine && item.lat && item.lon) {
            return {
                parentIndex: index,
                lat: item.lat,
                lng: item.lon
            };
        } else if (item.latitude && item.longitude) {
            return {
                parentIndex: index,
                lat: item.latitude,
                lng: item.longitude
            };
        }
    });

    if (smallArray.length > 1 && clickedPoint && clickedPoint.latlng) {
        // this method is used to generate additional point on polyLine to return one closest to clicked point
        let pointLatLng = getClosestPointOnPolyLineToClicked(smallArray, clickedPoint, zoomLevel);

        if (pointLatLng) {
            const indexOfClosestPoint = pointLatLng.parentIndex;
            const closestPoint = linePoints[indexOfClosestPoint];
            const distanceBetweenClickAndClosestPoints = CourseUtil.calculateDistanceBetweenPointsInMeters(
                closestPoint.lat ? closestPoint.lat : closestPoint.latitude,
                closestPoint.lon ? closestPoint.lon : closestPoint.longitude,
                pointLatLng.lat,
                pointLatLng.lng
            );
            let pointDistance = closestPoint.distance - distanceBetweenClickAndClosestPoints;

            let pointData = {
                indexToAddThePointAt: indexOfClosestPoint,
                distance: pointDistance,
                latitude: pointLatLng.lat,
                longitude: pointLatLng.lng,
                elevation: closestPoint.elevation,
                courseLine: courseLine ? courseLine : false
            };

            return { ...pointData };
        }
    }

    return null;
};

/**
 *
 * @param coursePointSelection
 * @param {boolean} switchViewEditException
 * @returns {boolean}
 */
export const shouldUseAddCoursePointCard = (coursePointSelection, switchViewEditException = false) => {
    // start and finish have special behavior as they aren't true course points (only local for display reasons)
    // an exception when switching between View and Edit Course then needing to open the Start/Finish points
    if (
        coursePointSelection?.pointType?.coursePointType === START_FINISH_COURSE_POINT_TYPES.start ||
        coursePointSelection?.pointType?.coursePointType === START_FINISH_COURSE_POINT_TYPES.finish
    ) {
        return switchViewEditException;
    }

    return !!(coursePointSelection && coursePointSelection.pointType);
};
/**
 *
 * @param coursePointSelection
 * @returns {boolean}
 */
export const isCoursePointAddedOnMap = (coursePointSelection) => {
    return !!(coursePointSelection && coursePointSelection.pointType && coursePointSelection.pointLocation);
};

/**
 *
 * @param pointData
 * @param listOfPoints
 * @returns {*}
 */
export const getPointMarkerIfAlreadySetAtLocation = (pointData = {}, listOfPoints = []) => {
    if (listOfPoints && listOfPoints.length && typeof pointData === 'object') {
        return listOfPoints.find((point) => {
            if (pointData.lat && pointData.lon) {
                return point.lat === pointData.lat && point.lon === pointData.lon;
            } else {
                return point.lat === pointData.latitude && point.lon === pointData.longitude;
            }
        });
    }
};

/**
 *
 * @param courseLines
 * @returns {{elevation, longitude, latitude, timestamp, distance}[]}
 */
export const getGeoPointsFromCourseSegmentLines = (courseLines) => {
    let newPoints = [];

    courseLines.forEach((line) => {
        if (line.points && line.points.length) {
            newPoints.push(...line.points);
        }
    });

    newPoints = newPoints.map((point) => {
        return createCourseGeoPointFromLinePoint(point);
    });

    //strips the duplicated points - witch are the start and end of a line
    stripDupDistancesFromPoints(newPoints, 'distance');

    return newPoints;
};

/**
 * similar to the CourseUtils.stripDupDistancesFromPoints method - except we also exclude the cases were the point has coursePointId
 * - because these could be received as duplicated on fetch popular route or follow roads and if set before it will remove the coursePointId even if it whould look similar
 * @param points
 * @param distanceIndex
 */
export const stripDupDistancesFromPoints = (points, distanceIndex) => {
    for (let i = 1; i < points.length; i++) {
        const previousPoint = points[i - 1];
        const currentPoint = points[i];
        //if distance is the same and if the current point does not have a coursePointId
        if (currentPoint && previousPoint) {
            if (currentPoint[distanceIndex] === previousPoint[distanceIndex] && !currentPoint.coursePointId) {
                points.splice(i, 1);

                // if we remove a point we need to check the same index again
                i--;
            }
        }
    }
};

/**
 *
 * @param line
 * @param point
 * @returns {[(*&{distanceInMeters: *, numberOfPoints, points: *}),(*&{distanceInMeters: *, numberOfPoints, points: *})]}
 */
export const getTwoLinesFromOneLineAtPoint = (line, point) => {
    let linePointFormat = createCourseLinePoint(point);
    //add the actually clicked point in the point array
    let linePoints = [...line.points];
    linePoints.splice(point.indexToAddThePointAt, 0, linePointFormat);
    let firstLinePoints = linePoints.slice(0, point.indexToAddThePointAt + 1);
    let firstLineDistance = getLineDistanceFromPoints(firstLinePoints);
    let firstLine = {
        ...line,
        points: firstLinePoints,
        distanceInMeters: firstLineDistance,
        numberOfPoints: firstLinePoints.length
    };
    let secondLinePoints = linePoints.slice(point.indexToAddThePointAt, linePoints.length);
    let secondLineDistance = getLineDistanceFromPoints(secondLinePoints);
    let secondLine = {
        ...line,
        points: secondLinePoints,
        distanceInMeters: secondLineDistance,
        numberOfPoints: secondLinePoints.length,
        sortOrder: line.sortOrder + 1
    };

    return [firstLine, secondLine];
};

/**
 * used to add a point at selected location an split that line into two separate lines/segments
 * @param lines
 * @param pointToAdd
 * @returns {{length}|*|*[]}
 */
export const splitLineAtNewAddedPoint = (lines, pointToAdd) => {
    if (lines.length && pointToAdd && pointToAdd.courseLine) {
        let linesToAdd = getTwoLinesFromOneLineAtPoint(pointToAdd.courseLine, pointToAdd);
        let shouldIncrementSortOrder = false;
        let newLines = [];

        lines.forEach((line, index) => {
            if (line.sortOrder === pointToAdd.courseLine.sortOrder) {
                shouldIncrementSortOrder = true;
            } else if (shouldIncrementSortOrder) {
                newLines.push({
                    ...line,
                    sortOrder: line.sortOrder + 1
                });
            } else {
                //do not return the line.sortOrder === pointToAdd.courseLine.sortOrder
                newLines.push(line);
            }
        });

        linesToAdd.forEach((lineToAdd) => {
            //sort order does not include the 0 index
            newLines.splice(lineToAdd.sortOrder - 1, 0, lineToAdd);
        });

        return newLines;
    }

    return lines;
};

/**
 *
 * @param courseLines
 * @param coursePointsMarkers
 * @returns {*}
 */
export const setPointMarkerIdInCoursePoint = (courseLines, coursePointsMarkers) => {
    if (coursePointsMarkers && coursePointsMarkers.length) {
        coursePointsMarkers.forEach((marker) => {
            let foundItem;
            let distanceBetweenMarkerAndPoint;

            courseLines.forEach((line) => {
                line.points.forEach((point) => {
                    let tempDistanceDiff = Math.abs(marker.distance - point.distance);

                    if (!distanceBetweenMarkerAndPoint || tempDistanceDiff < distanceBetweenMarkerAndPoint) {
                        foundItem = point;
                        distanceBetweenMarkerAndPoint = tempDistanceDiff;
                    }
                });
            });

            if (foundItem) {
                //set the id of the marker on the point
                foundItem.coursePointId = marker.coursePointId;
            }
        });
    }

    return courseLines;
};

/**
 *
 * @param points
 * @param marker
 * @returns {{foundPoint: *, findPointAtIndex}}
 */
export const findMarkerInLinePoints = (points, marker) => {
    let findPointAtIndex;
    // go through each point in the line - if there is a maker on the point stop the delete at that marker
    let foundPoint = points.find((point, index) => {
        // in case the marker was recently added and not sent to api check by tempId that should be added on the add point in AddCoursePoint setCoursePointData
        let markerThatWasAddedNow =
            !marker.coursePointId && point.tempId && marker.tempId && point.tempId === marker.tempId;

        if ((marker.coursePointId && point.coursePointId === marker.coursePointId) || markerThatWasAddedNow) {
            findPointAtIndex = index;
        }
        return (marker.coursePointId && point.coursePointId === marker.coursePointId) || markerThatWasAddedNow;
    });

    return {
        findPointAtIndex: findPointAtIndex,
        foundPoint: foundPoint
    };
};

/**
 *
 * @param line
 * @param coursePointsMarkers
 * @returns {{indexInLinePoints: *, marker: *}[]}
 */
export const findPointsMarkerInLine = (line, coursePointsMarkers) => {
    let indexesOfFoundMarkersInPoints = [];

    if (line && line.points && coursePointsMarkers && coursePointsMarkers.length) {
        [...coursePointsMarkers].forEach((marker) => {
            let foundPoint = findMarkerInLinePoints(line.points, marker);

            if (!isNaN(foundPoint.findPointAtIndex)) {
                indexesOfFoundMarkersInPoints.push({
                    marker: { ...marker },
                    indexInLinePoints: foundPoint.findPointAtIndex
                });
            }
        });
    }

    return indexesOfFoundMarkersInPoints;
};

export const updateCourseMarkersDistanceBasedOnLines = (lines, markers) => {
    if (markers && markers.length) {
        markers.forEach((marker) => {
            lines.find((line) => {
                let foundPoint = findMarkerInLinePoints(line.points, marker);

                if (foundPoint && foundPoint.foundPoint && !isNaN(foundPoint.findPointAtIndex)) {
                    //overwrite the distance of the marker - since it is a reference it should persist
                    marker.distance = foundPoint.foundPoint.distance;

                    return line;
                }
            });
        });

        //sort course points based on distance because that is how it is required by API
        markers.sort((a, b) => {
            return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
        });
    }

    return markers;
};

/**
 *
 * @param indexesOfFoundMarkersInPoints
 * @param line
 * @param isLastLine
 * @returns {{markerToBeRemoved: *, lineChanged: (*&{distanceInMeters: number, numberOfPoints, points: *})}}
 */
export const getNewLineDataWithLineChangedFromIndex = (indexesOfFoundMarkersInPoints, line, isLastLine = false) => {
    if (indexesOfFoundMarkersInPoints && indexesOfFoundMarkersInPoints.length) {
        let lineToChange = {
            ...line
        };
        let markerToBeRemoved;
        //line can have multiple point markers/get the smallest since we are deleting the start
        let smallestIndex = indexesOfFoundMarkersInPoints.reduce(function(prev, curr) {
            if (isLastLine) {
                //if it is the last line then get point closest to end
                return prev.indexInLinePoints > curr.indexInLinePoints ? prev : curr;
            } else {
                //if it is the start line then get point closest to start
                return prev.indexInLinePoints < curr.indexInLinePoints ? prev : curr;
            }
        });
        let firstItemIndex = smallestIndex.indexInLinePoints;
        let lastItemIndex = lineToChange.points.length - 1;

        if (isLastLine) {
            lastItemIndex = firstItemIndex; // the end index is the last item of the line on end delete
            firstItemIndex = 0; // the start index is the start of the line on end delete
        }

        let newPointsForLine = lineToChange.points.slice(firstItemIndex, lastItemIndex + 1);
        let lineDistance = getLineDistanceFromPoints(newPointsForLine); // total line distance should be the end point distance - the new start initial distance

        lineToChange = {
            ...lineToChange,
            distanceInMeters: lineDistance,
            points: newPointsForLine, //slice from smallest index to last point
            numberOfPoints: newPointsForLine.length
        };
        markerToBeRemoved = smallestIndex.marker;

        return {
            lineChanged: lineToChange,
            markerToBeRemoved: markerToBeRemoved
        };
    }
};

/**
 *
 * @param lines
 * @param coursePointsMarkers
 * @param isLastLine
 * @returns {{newCoursePoints: *[], newLines: any}}
 */
export const removeLineWithSetSortOrdersAndCoursePointMarkers = (
    lines,
    coursePointsMarkers = [],
    isLastLine = false
) => {
    //remove deep reference of objects
    let string = JSON.stringify(lines);
    let newLines = JSON.parse(string);
    let lineToChange = isLastLine ? newLines[newLines.length - 1] : newLines[0];
    let markerToBeRemoved;
    let indexesOfFoundMarkersInPoints = findPointsMarkerInLine(lineToChange, coursePointsMarkers);

    if (indexesOfFoundMarkersInPoints && indexesOfFoundMarkersInPoints.length) {
        let data = getNewLineDataWithLineChangedFromIndex(indexesOfFoundMarkersInPoints, lineToChange, isLastLine);
        if (isLastLine) {
            newLines[newLines.length - 1] = {
                ...data.lineChanged
            };
        } else {
            newLines[0] = {
                ...data.lineChanged
            };
        }

        markerToBeRemoved = data.markerToBeRemoved;
    } else {
        if (isLastLine) {
            newLines.pop();
        } else {
            //if no makers were found then just remove the first line
            newLines.shift();
        }
    }
    let incrementalDistance = 0;
    newLines.forEach((item, index) => {
        item.sortOrder = index + 1;
        populateDistanceInGeoPointsByKey(item.points, incrementalDistance);
        item.numberOfPoints = item.points.length;
        incrementalDistance = item.points[item.points.length - 1].distance;
        item.distanceInMeters = getLineDistanceFromPoints(item.points);
    });

    let newMarkers = coursePointsMarkers && coursePointsMarkers.length ? [...coursePointsMarkers] : [];
    let returnObject = {
        newLines: newLines,
        newCoursePoints: newMarkers
    };

    if (markerToBeRemoved) {
        returnObject.newCoursePoints = filterOutPointMarkerFromCoursePointsMarkers(newMarkers, markerToBeRemoved);
    }

    return returnObject;
};

/**
 * used to remove combine two segments into one on segment/line marker delete click
 * @param allLines
 * @param clickedSegmentMarker
 * @param clickedSegmentLine
 */
export const removeSegmentOnDeleteSegmentMarker = (allLines, clickedSegmentMarker, clickedSegmentLine) => {
    let newLines = [...allLines];

    //the course line marker is always based on the first point - look into getCourseLinesSegmentMarkers
    //also start point is skipped(not a line marker) so no need to check if it has previous lines
    if (
        clickedSegmentMarker &&
        clickedSegmentMarker.lat &&
        clickedSegmentMarker.lon &&
        clickedSegmentLine &&
        clickedSegmentLine.points &&
        clickedSegmentLine.points.length &&
        clickedSegmentLine.sortOrder > 1
    ) {
        //starting at 0 because we will increment BEFORE returning the object and not in all cases
        let newSortOrder = 0;

        newLines = newLines
            .map((line) => {
                if (line.sortOrder === clickedSegmentLine.sortOrder - 1) {
                    let cumulativeDistance = line.distanceInMeters + clickedSegmentLine.distanceInMeters;
                    let cumulativePoints = [...line.points, ...clickedSegmentLine.points];
                    stripDupDistancesFromPoints(cumulativePoints, 'distance');
                    newSortOrder = newSortOrder + 1;

                    return {
                        ...line,
                        distanceInMeters: cumulativeDistance,
                        numberOfPoints: cumulativePoints.length,
                        points: cumulativePoints,
                        sortOrder: newSortOrder
                    };
                } else if (!(line.sortOrder === clickedSegmentLine.sortOrder)) {
                    newSortOrder = newSortOrder + 1;
                    return {
                        ...line,
                        sortOrder: newSortOrder
                    };
                }
            })
            .filter(Boolean);
    }

    return newLines;
};

/**
 *
 * @param coursePoints
 * @param marker
 * @returns {*[]}
 */
export const filterOutPointMarkerFromCoursePointsMarkers = (coursePoints, marker) => {
    let newCoursePoint = coursePoints && coursePoints.length ? [...coursePoints] : [];

    //find by id if the point was saved or by lat lon if it was just set and not saved on API
    newCoursePoint = newCoursePoint.filter(
        (findItem) =>
            !(
                (marker.coursePointId && marker.coursePointId === findItem.coursePointId) ||
                (marker.lat === findItem.lat && marker.lon === findItem.lon)
            )
    );

    return newCoursePoint;
};

/**
 * return the freehandPoint
 * @param prevPointLat
 * @param prevPointLon
 * @param prevPointDistance
 * @param clickedPointLatLng
 * @returns {{distanceBetweenPoints: *, point: {elevation: *, distance: *, lon: *, lat: *}}}
 */
export const getPointToAddForFreehand = (prevPointLat, prevPointLon, prevPointDistance = 0, clickedPointLatLng) => {
    const distanceBetweenPoints = CourseUtil.calculateDistanceBetweenPointsInMeters(
        prevPointLat,
        prevPointLon,
        clickedPointLatLng.lat,
        clickedPointLatLng.lng
    );
    let point = {
        distance: distanceBetweenPoints + prevPointDistance,
        lat: clickedPointLatLng.lat,
        lon: clickedPointLatLng.lng,
        elevation: null
    };

    return {
        distanceBetweenPoints: distanceBetweenPoints,
        point: point
    };
};

/**
 * Creates a new line with 2 points
 * @param {*} lines
 * @param {*} pointToAddInNewLine
 */
export const addNewLineAtEnd = (lines, pointToAddInNewLine) => {
    const lastLine = lines[lines.length - 1];
    const lastLineLastPoint = lastLine.points[lastLine.points.length - 1];
    const distanceBetweenPoints = CourseUtil.calculateDistanceBetweenPointsInMeters(
        lastLineLastPoint.lat,
        lastLineLastPoint.lon,
        pointToAddInNewLine.lat,
        pointToAddInNewLine.lon
    );

    const points = [
        lastLineLastPoint,
        { ...pointToAddInNewLine, distance: lastLineLastPoint.distance + distanceBetweenPoints }
    ];
    const newLines = [
        ...lines,
        {
            ...lastLine,
            sortOrder: lastLine.sortOrder + 1,
            distanceInMeters: distanceBetweenPoints,
            points,
            numberOfPoints: points.length
        }
    ];

    return newLines;
};

export function getMapProviderUtil(initialProviderName, transMode) {
    let provider, transitMode;
    let providerName = initialProviderName;
    if (transMode && transMode.parent) {
        transitMode =
            transMode.parent === 'cycling' ? LeafletUtil.TRANSIT_MODE.CYCLING : LeafletUtil.TRANSIT_MODE.PEDESTRIAN;
    } else {
        transitMode = LeafletUtil.TRANSIT_MODE.PEDESTRIAN;
    }

    if (MapUtils.userInChina()) {
        providerName = Util.MapProviders.BAIDU;
    } else {
        if (providerName === Util.MapProviders.BAIDU) {
            providerName = Util.MapProviders.GOOGLE;
        }
    }
    switch (providerName) {
        case Util.MapProviders.OSM:
            provider = new GarminOpenStreetMapProvider({
                transitMode: transitMode,
                layerType: Util.MAP_LAYER_TYPES.ROAD
            });
            break;
        case Util.MapProviders.GOOGLE:
            provider = new GoogleMapProvider({
                transitMode: transitMode
            });
            break;
        case Util.MapProviders.HERE:
            provider = new HereMapProvider({
                transitMode: transitMode
            });
            break;
        case Util.MapProviders.BAIDU:
            provider = new BaiduMapProvider({
                transitMode: transitMode
            });
            break;
        default:
            return null;
    }
    return provider;
}

/**
 * used to process data for the store based on the received geoPoints from the map direction service
 * @param geoPoints
 * @param previousSetPoints
 * @returns {{geoPoints: ({length}|*), boundingBox: {lowerLeft: {latitude: *, longitude: *}, lowerLeftLongIsSet: boolean, upperRightLatIsSet: boolean, upperRightLongIsSet: boolean, upperRight: {latitude: *, longitude: *}, lowerLeftLatIsSet: boolean}, startPoint: (*|null), distanceMeter: *, courseLines: []}}
 */
export const getProcessedDataFromGeoPointsForFollowRoadsData = (geoPoints, courseData, previousSetPoints = []) => {
    let processedGeoPoints;
    let temporaryProcessedGeoPoints = geoPoints.map((point) => ({
        latitude: point[0],
        longitude: point[1],
        distance: null,
        timestamp: null
    }));

    if (previousSetPoints && previousSetPoints.length > 0) {
        //if previous points were added then prepend those points
        processedGeoPoints = [...previousSetPoints, ...temporaryProcessedGeoPoints];
    } else {
        processedGeoPoints = [...temporaryProcessedGeoPoints];
    }

    //add distance values and strip dups
    CourseUtil.populateDistanceInGeoPoints(processedGeoPoints);
    stripDupDistancesFromPoints(processedGeoPoints, 'distance');

    const processedData = getPointsChangedObject(processedGeoPoints);

    // get the newly added points by removing existing points
    const newProcessedGeoPoints = processedData.geoPoints.slice(courseData.geoPoints.length - 1);
    // create the course lines based on the newly added points
    const newCourseLines = setCourseLines(false, newProcessedGeoPoints, courseData);

    return {
        ...processedData,
        courseLines: newCourseLines
    };
};
/**
 * Formats the course points and lines before saving
 * @param {{editableCourseDetails:object, coursePointSelection:object, pointLocation}}
 * @returns {{ allCoursePoints, newCourseLines, setCoursePointData }}
 */

export function formatDataBeforeSave({ editableCourseDetails, coursePointSelection, pointLocation }) {
    const { pointType, editModeMarkerInitialValue } = coursePointSelection;
    const { coursePoints, courseLines, courseId } = editableCourseDetails;

    let allCoursePoints = coursePoints && coursePoints.length ? [...coursePoints] : [];
    let indexToAddThePointAt = pointLocation.indexToAddThePointAt;
    let courseLine = pointLocation.courseLine;
    let tempId = new Date().getTime();

    let setCoursePointData = {
        ...pointType,
        distance: pointLocation.distance,
        lat: pointLocation.latitude,
        lon: pointLocation.longitude,
        elevation: pointLocation.elevation,
        timestamp: null,
        coursePointId: null, // if in edit - reset the coursePointId - API also resets it on each post - this way we do not need to reuse and set on the new course line point
        tempId: tempId
    };
    let newPointToAdd = {
        distance: setCoursePointData.distance,
        elevation: setCoursePointData.elevation,
        latitude: setCoursePointData.lat,
        longitude: setCoursePointData.lon,
        timestamp: setCoursePointData.timestamp,
        tempId: setCoursePointData.tempId
    };
    let newCourseLines = courseLines ? [...courseLines] : [];

    if (!isNaN(indexToAddThePointAt) && courseLine && courseLine.points) {
        //need to increase the courseLine/segment points with the point that was just added in the geoPoints array
        newCourseLines = courseLines.map((singleLine) => {
            if (courseLine.sortOrder === singleLine.sortOrder) {
                let linePointToAdd = createCourseLinePoint(newPointToAdd);
                let incrementedPoints = [...singleLine.points];
                //remove course point marker reference in the line point
                incrementedPoints.forEach((point) => {
                    if (
                        editModeMarkerInitialValue &&
                        editModeMarkerInitialValue.coursePointId &&
                        editModeMarkerInitialValue.coursePointId === point.coursePointId
                    ) {
                        point.coursePointId = null;
                    }
                });
                incrementedPoints.splice(indexToAddThePointAt, 0, linePointToAdd);

                return {
                    ...singleLine,
                    numberOfPoints: singleLine.numberOfPoints + 1,
                    points: incrementedPoints
                };
            }
            return singleLine;
        });
    }

    //remove the values not needed for the course point on save - or for the post payload
    delete setCoursePointData.limitedLabel;
    delete setCoursePointData.label;
    delete setCoursePointData.longitude; //longitude can be on the object if in edit mode
    delete setCoursePointData.latitude; //latitude can be on the object if in edit mode
    delete setCoursePointData.value;

    //if coursePk is available and is not set from edit mode
    if (courseId && !setCoursePointData.coursePk) {
        setCoursePointData.coursePk = courseId;
    }

    //if in edit mode remove the marker from the array before adding the new edited one
    if (editModeMarkerInitialValue) {
        //find by id if the point was saved or by lat lon if it was just set and not saved on API
        allCoursePoints = allCoursePoints.filter(
            (findItem) => !isMarkerPointSameAsGivenPoint(editModeMarkerInitialValue, findItem)
        );
    }

    allCoursePoints.push(setCoursePointData);
    allCoursePoints.sort((a, b) => {
        return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
    });
    return { allCoursePoints, newCourseLines, setCoursePointData };
}

/**
 * used to compare a marker with a line geoPoint to see if it is the location of the marker we are working on
 * @param markerPoint
 * @param givenPoint
 * @returns {*|boolean}
 */
export const isMarkerPointSameAsGivenPoint = (markerPoint, givenPoint) => {
    // start/finish could be the same lat/lon if automatic drawing method used, so only check the temp id
    if (
        givenPoint?.coursePointType === START_FINISH_COURSE_POINT_TYPES.start ||
        givenPoint?.coursePointType === START_FINISH_COURSE_POINT_TYPES.finish
    ) {
        return markerPoint.tempId && markerPoint.tempId === givenPoint.tempId;
    }
    return (
        (markerPoint.coursePointId && markerPoint.coursePointId === givenPoint.coursePointId) ||
        (markerPoint.tempId && markerPoint.tempId === givenPoint.tempId) ||
        (markerPoint.lat === givenPoint.lat && markerPoint.lon === givenPoint.lon)
    );
};
/**
 *
 * @param linePoints
 * @param markers
 * @param getReversed
 * @returns {*}
 */
export const getLineEndOrClosestMarker = (linePoints = [], markers = [], getReversed = false) => {
    let string = JSON.stringify(linePoints);
    let searchInLinePoints = JSON.parse(string);

    // don't consider these course point types when recalculating the course polyline based on user dragging points around on the map
    const filteredMarkers = markers.filter(
        (mkr) => ![MARKER_MILE, MARKER_KILOMETER, MARKER_HALF_MARATHON].includes(mkr?.coursePointType)
    );

    if (getReversed && searchInLinePoints.length) {
        //this is used to get the closest value to the end of the line and not the start - when moving the end point as an example
        searchInLinePoints.reverse();
    }

    let foundPoint = searchInLinePoints.find((point) => {
        if (point.coursePointId && filteredMarkers) {
            //found marker that was set and got from API
            return filteredMarkers.find((marker) => {
                return marker.coursePointId === point.coursePointId;
            });
        } else if (point.tempId && filteredMarkers) {
            //found marker that was just set on client
            return filteredMarkers.find((marker) => {
                return marker.tempId === point.tempId;
            });
        }

        return false;
    });

    if (!foundPoint) {
        //if no markers were found return the line end point
        foundPoint = searchInLinePoints[searchInLinePoints.length - 1];
    }

    return foundPoint;
};

/**
 * check for the maximum value allowed for the course length for power guide or pace pro if the user has any of those on the course
 * @param measurementSystem
 * @param hasPaceBand
 * @param hasPowerGuide
 * @returns {number}
 */
export const getMaxValueAllowed = (measurementSystem = 'metric', hasPaceBand = false, hasPowerGuide = false) => {
    if (hasPowerGuide) {
        if (measurementSystem === Personalizer.MeasurementSystems.METRIC) return MAX_COURSE_DISTANCE_KM;
        else return MAX_COURSE_DISTANCE_MILES;
    }
    // PacePro
    if (hasPaceBand) {
        if (measurementSystem === Personalizer.MeasurementSystems.METRIC) return PACE_PRO_MAX_COURSE_DISTANCE_KM;
        else return PACE_PRO_MAX_COURSE_DISTANCE_MILES;
    }
};

/**
 * check for the minimum value allowed for the course length for power guide or pace pro if the user has any of those on the course
 * @param measurementSystem
 * @param hasPaceBand
 * @param hasPowerGuide
 * @returns {number}
 */
export const getMinValueAllowed = (measurementSystem, hasPaceBand, hasPowerGuide) => {
    if (hasPowerGuide) {
        if (measurementSystem === Personalizer.MeasurementSystems.METRIC) return MIN_COURSE_DISTANCE_KM;
        else return MIN_COURSE_DISTANCE_MILES;
    }
    // PacePro
    if (hasPaceBand) {
        if (measurementSystem === Personalizer.MeasurementSystems.METRIC) return PACE_PRO_MIN_COURSE_DISTANCE_KM;
        else return PACE_PRO_MIN_COURSE_DISTANCE_MILES;
    }
};

/**
 * creates the first line un until a drag/drop of point of the polyline - second line will come and complete the route change
 * returns the updated lines
 * @param lines
 * @param newPoint
 * @param upUntilPoint
 * @param fromPoint
 * @param dragLineData
 * @returns {*}
 */
export const setPrevLines = (lines, newPoint, upUntilPoint, fromPoint, dragLineData) => {
    let prevLine = lines.find((line) => line.sortOrder === dragLineData.sortOrder - 1);
    let findUpUntilPointInPreviousLine = prevLine.points.find((point) => {
        let isDistanceTheSame = upUntilPoint.distance === point.distance;

        return point.lat === upUntilPoint.lat && upUntilPoint.lon === point.lon && isDistanceTheSame;
    });

    return createNewLineFromCutOfUntilPoint(lines, prevLine.sortOrder, newPoint, findUpUntilPointInPreviousLine, true);
};

/**
 * creates the second line from a drag/drop of point of the polyline - comes after the first line was created up until the point
 * returns the updated lines
 * @param lines
 * @param newPoint
 * @param upUntilPoint
 * @param fromPoint
 * @param dragLineData
 * @returns {*}
 */
export const setCurrentLines = (lines, newPoint, upUntilPoint, fromPoint, dragLineData) => {
    let findFromPointInLine = dragLineData.points.find((point) => {
        let isDistanceTheSame = fromPoint.distance === point.distance;

        return point.lat === fromPoint.lat && fromPoint.lon === point.lon && isDistanceTheSame;
    });

    return createNewLineFromCutOfUntilPoint(lines, dragLineData.sortOrder, newPoint, findFromPointInLine);
};

/**
 * changes a line usually start of end line, with a different set of points
 * removes the old points up until(or from if isEndingWithLimitPoint) then adds the new received points in there place
 * @param linesData
 * @param lineSortOrder
 * @param newPoints
 * @param targetPoint
 * @param isEndingWithLimitPoint
 * @returns {any}
 */
export const createNewLineFromCutOfUntilPoint = (
    linesData,
    lineSortOrder,
    newPoints,
    targetPoint,
    isEndingWithLimitPoint = false
) => {
    let stringLines = JSON.stringify(linesData);
    let lines = JSON.parse(stringLines);
    let line = lines.find((singleLine) => singleLine.sortOrder === lineSortOrder);
    let shouldFilterOutItem = isEndingWithLimitPoint; // if the line should end with the limit point then it should filter out initialItems

    //filter out points in the line up until or after the targetPoint - depending on direction
    line.points = line.points.filter((point, pointIndex) => {
        if (point.lat === targetPoint.lat && point.lon === targetPoint.lon) {
            //in case isEndingWithLimitPoint is true then the filtering should stop and not start
            shouldFilterOutItem = !isEndingWithLimitPoint; // in case we have duplicate items make sure not to negate multiple times the same value- so use attribute
            return false; // filter out found item to prevent having duplicate items
        } else {
            return shouldFilterOutItem;
        }
    });
    let newEndPoint;

    newPoints.forEach((newPoint) => {
        newEndPoint = {
            latitude: newPoint[0],
            longitude: newPoint[1]
            // ignore elevation, it will be fetched automatically when updating the lines and geoPoints
        };

        if (isEndingWithLimitPoint) {
            line.points.push(createCourseLinePoint(newEndPoint));
        } else {
            line.points.splice(0, 0, createCourseLinePoint(newEndPoint));
        }
    });

    lines = updateLinesDataWithDistanceForEachPoint(lines);

    return lines;
};

/**
 * used to update the line date with the line distance and cumulative distance for each line point via the populateDistanceInGeoPointsByKey func
 * @param linesData
 * @param {boolean} [keepGeoPointsDistance] when true, we expect input `linesData` has correct `distance`, so we don't calculate distance again
 * @returns {any}
 */
export const updateLinesDataWithDistanceForEachPoint = (linesData, keepGeoPointsDistance = false) => {
    let stringLines = JSON.stringify(linesData);
    let lines = JSON.parse(stringLines);
    let incrementalDistance = 0;
    //update the distance with the difference - if start is changed all points distance change
    lines.forEach((item, lineIndex) => {
        if (!keepGeoPointsDistance) {
            //recalculate the distance between all points - too difficult to cumulative add and prone to issues
            populateDistanceInGeoPointsByKey(item.points, incrementalDistance);
        }
        incrementalDistance = item.points[item.points.length - 1].distance;
        item.numberOfPoints = item.points.length;
        item.sortOrder = lineIndex + 1;
        item.distanceInMeters = getLineDistanceFromPoints(item.points);
    });

    return lines;
};

/**
 * Attention:
 *
 * Within this function we add `distance` to each geoPoint calculated by Leaflet map lib. But the calculation has high difference between API and Web.
 * Use only you need to.
 *
 * @summary
 * same as populateDistanceInGeoPoints from CourseUtil.js - changed lat lon and added cumulative distance option
 * @param geoPoints
 * @param cumulativeDistance
 * @param latitudeKey
 * @param longitudeKey
 * @returns {*}
 */
export const populateDistanceInGeoPointsByKey = (
    geoPoints,
    cumulativeDistance = 0,
    latitudeKey = 'lat',
    longitudeKey = 'lon'
) => {
    let distance = cumulativeDistance,
        previousPoint;

    if (geoPoints && geoPoints.length) {
        for (let i = 0, len = geoPoints.length; i < len; i += 1) {
            if (geoPoints[i]) {
                if (previousPoint) {
                    distance += CourseUtil.calculateDistanceBetweenPointsInMeters(
                        previousPoint[latitudeKey],
                        previousPoint[longitudeKey],
                        geoPoints[i][latitudeKey],
                        geoPoints[i][longitudeKey]
                    );
                }

                previousPoint = geoPoints[i];

                geoPoints[i].distance = distance;
            }
        }
    }

    return geoPoints;
};

export const getAvailableCourseTypes = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirectUrl');

    if (redirectUrl) {
        if (redirectUrl.indexOf('power-guidance') !== -1) {
            return CourseTypes.filter((type) => {
                //return the cycling parent activity types excluding other
                return type.parentType === 'cycling' && type.typeValue !== 'other';
            });
        } else if (redirectUrl.indexOf('pacepro') !== -1) {
            return CourseTypes.filter((type) => {
                return type.parentType === 'running' && type.typeValue !== 'hiking';
            });
        }
    }
    // the obstacle running type is available only when we save an activity as course and not in the dropdown
    return CourseTypes.filter((course) => course.value !== 'activity_type_obstacle_run');
};

export const hasCoursesButWereFilteredOut = (totalNumberOfCourses, numberOfFilteredCourses) => {
    return totalNumberOfCourses > 0 && numberOfFilteredCourses === 0;
};

export const getCourseTypeInfo = (editableCourseDetails, activityTypes, directActivityTypePk = false) => {
    let courseTypeValue, courseType;
    let typePk = directActivityTypePk
        ? directActivityTypePk
        : editableCourseDetails && editableCourseDetails.activityTypePk
        ? editableCourseDetails.activityTypePk
        : false;

    if (activityTypes && activityTypes.length && typePk) {
        courseType = getCourseTypeDataBasedOnActivityTypeKey(activityTypes, typePk);
        courseTypeValue = courseType && courseType.typeValue;
    }

    return {
        courseType: courseType,
        supportedPopularityType: courseTypeValue ? SupportedPopularityTypes[courseTypeValue.toUpperCase()] : 'none'
    };
};

/**
 *
 * @param leafletMainMap
 * @param successCallback
 * @param errorCallback
 */
export const navigateToUsersLocation = (leafletMainMap, successCallback, errorCallback) => {
    if (leafletMainMap && leafletMainMap.locate && leafletMainMap.on) {
        leafletMainMap
            .locate({
                maxZoom: MAP_DEFAULT_ZOOM_LEVEL,
                setView: true
            })
            .on('locationfound', (e) => {
                if (typeof successCallback === 'function') {
                    successCallback();
                }
            })
            .on('locationerror', (e) => {
                if (typeof errorCallback === 'function') {
                    errorCallback();
                }
            });
    }
};

/**
 *
 * @param previousPoints
 * @param currentPoints
 */
export const wereCourseGeoPointsChanged = (previousPoints, currentPoints) => {
    return !!(previousPoints && currentPoints && JSON.stringify(previousPoints) !== JSON.stringify(currentPoints));
};

export const pushCoursesAnalytics = (action, label = '') => {
    let obj = {
        event: 'track_event',
        category: 'Courses',
        action: action
    };

    if (label) {
        obj['label'] = label;
    }

    AnalyticsUtil.push(obj);
};

export const validateRestDuration = (time) => {
    const maxTime = MAX_REST_BREAK_DURATION_SECONDS; // max Rest Duration is 1 hr - 1 second
    let valid = time >= 0;
    if (maxTime) {
        valid = time >= 0 && time <= maxTime;
    }

    return valid;
};

export const validateCutoffDuration = (time) => {
    const maxTime = MAX_CUTOFF_DURATION_SECONDS; // max Cutoff Duration is 100 hrs - 1 second
    let valid = time >= 0;
    if (maxTime) {
        valid = time >= 0 && time <= maxTime;
    }

    return valid;
};

/**
 * Checks to see if the editable course data course lines have new points
 */
export const hasNewCourseLinesPoints = (prevEditableCourseData, editableCourseData) => {
    const prevCourseLines = prevEditableCourseData?.courseLines;
    const currCourseLines = editableCourseData?.courseLines;

    const hasNewLines = prevCourseLines.some((line, index) => {
        return line?.points?.length !== currCourseLines[index]?.points?.length;
    });

    return hasNewLines;
};

/**
 * Adds in the Start and Finish Course Points using the new geoPoints data
 * Start/Finish Course Points are only shown to the Client and NEVER saved to API. They are removed when calling API
 * @param {*} editableCourseData
 * @param {*} geoPoints
 * @param {boolean} [undo] function is called with "undo" action, we used previous distance if exist
 */
export const setStartFinishCoursePoints = (editableCourseData, geoPoints, undo = false) => {
    if (geoPoints?.length === 0 || undo) return editableCourseData.coursePoints;

    const firstGeoPoint = geoPoints.at(0),
        lastGeoPoint = geoPoints.at(-1);
    let newCoursePoints = [];

    const existingStartPoint =
        editableCourseData?.coursePoints?.find((point) => {
            return point.coursePointType === START_FINISH_COURSE_POINT_TYPES.start;
        }) ?? {};

    const existingFinishPoint =
        editableCourseData?.coursePoints?.find((point) => {
            return point.coursePointType === START_FINISH_COURSE_POINT_TYPES.finish;
        }) ?? {};

    const newStartPoint = {
        ...existingStartPoint,
        lat: firstGeoPoint.latitude,
        lon: firstGeoPoint.longitude,
        elevation: firstGeoPoint.elevation,
        distance: firstGeoPoint.distance,
        note: editableCourseData?.startNote ?? null,
        name: i18next.t('course:course_start'),
        tempId: new Date().getTime(),
        coursePointType: START_FINISH_COURSE_POINT_TYPES.start
    };

    const newFinishPoint = {
        ...existingFinishPoint,
        lat: lastGeoPoint.latitude,
        lon: lastGeoPoint.longitude,
        elevation: lastGeoPoint.elevation,
        distance: lastGeoPoint.distance,
        note: editableCourseData?.finishNote ?? null,
        cutoffDuration: editableCourseData?.cutoffDuration ?? null,
        name: i18next.t('course:course_finish'),
        tempId: new Date().getTime() + 1,
        coursePointType: START_FINISH_COURSE_POINT_TYPES.finish
    };

    // include the existing points if they exist
    editableCourseData?.coursePoints && newCoursePoints.push(...editableCourseData.coursePoints);

    // remove existing start/finish if they exist
    if (existingStartPoint || existingFinishPoint) {
        newCoursePoints = newCoursePoints.filter((point) => {
            return (
                point.coursePointType !== START_FINISH_COURSE_POINT_TYPES.start &&
                point.coursePointType !== START_FINISH_COURSE_POINT_TYPES.finish
            );
        });
    }

    // insert new start/finish into array with existing points
    newCoursePoints.splice(0, 0, newStartPoint);
    newCoursePoints.splice(newCoursePoints.length, 0, newFinishPoint);

    return newCoursePoints;
};

/**
 * Removes Start/Finish course points before sending to API
 * @param editableCourseDetails
 */
export const removeStartFinishCoursePointsForSave = (editableCourseDetails) => {
    const filteredCourseDetails = { ...editableCourseDetails };

    if (editableCourseDetails?.coursePoints?.length > 0) {
        filteredCourseDetails.coursePoints = filteredCourseDetails.coursePoints.filter((point) => {
            // cleanup cached lab by course point data before sending to API
            if (Object.keys(point).includes('lapByCoursePointValue')) {
                delete point.lapByCoursePointValue;
            }

            return (
                point.coursePointType !== START_FINISH_COURSE_POINT_TYPES.start &&
                point.coursePointType !== START_FINISH_COURSE_POINT_TYPES.finish
            );
        });
    }

    return filteredCourseDetails;
};

/**
 * Used to determine if the course is a Course Planner (planned) course. A planned course consists of:
 * Start point -- has notes only
 * Finish point -- has notes or cutoff duration only
 * Any other course point -- has notes, rest break duration, or cutoff duration
 * @param editableCourseDetails
 */
export const isPlannedCourse = (editableCourseDetails) => {
    const { coursePoints } = editableCourseDetails;

    const hasNotes = coursePoints.some((point) => {
        return !!point.note;
    });

    const hasRestBreaks = coursePoints.some((point) => {
        return !!point.restDuration;
    });

    const hasCutoffDurations = coursePoints.some((point) => {
        return !!point.cutoffDuration;
    });

    return hasNotes || hasRestBreaks || hasCutoffDurations;
};

/**
 * The following is adapted from the course point Overlapping Poly Line Detection algorithm documented here:
 * https://confluence.garmin.com/display/DI/Course+Planner+Phase+1+Technical+Details
 *
 * Originally it was a class and in Typescript to support a local Proof of Concept. It's been adapted to
 * functional style and to support it being used in the current Courses implementation
 *
 * When user chooses a new location for a Course Point, we will detect if multiple points overlap where they
 * clicked, and present those multiple locations to them.
 *
 * This algorithm allows for controls of how close or how far in the Course we use to detect overlapping points
 * using the consts COURSE_POINT_DISTANCE_BUFFER_METERS, COURSE_POINT_DISTANCE_THRESHOLD_METERS,
 * COURSE_POINT_DEFAULT_LENGTH
 */

/**
 * @typedef {Object} GeoPoint - GeoPoint used for Course Point Selection Overlap
 * @prop {number} lat - latitude - selectedPoint uses this key
 * @prop {number} lon - longitude - selectedPoint uses this key
 * @prop {number} [latitude] - actual data from API may have the longer name - geoPoints uses this key
 * @prop {number} [longitude] - actual data from API may have the longer name - geoPoints uses this key
 * @prop {number} distance - distance (meters) of point in the overall Course
 * @prop {number} [index] - index of this specific point in the array
 */

/**
 * @typedef {Object} Bbox - bounding box
 * @prop {number} minX
 * @prop {number} maxX
 * @prop {number} minY
 * @prop {number} maxY
 */

/**
 * Helper functions to make the data conform as needed
 */

/**
 * New GeoPoint object
 * @param {number} lat - latitude
 * @param {number} lon - longitude
 * @param {number} [distance=0] - distance of the GeoPoint in the course
 * @param {number} [index=-1] - index of the GeoPoint in the array of GeoPoints
 * @returns {GeoPoint}
 */
const createGeoPoint = (lat, lon, distance = 0, index = -1) => {
    return {
        lat,
        lon,
        distance,
        index
    };
};

/**
 * Takes raw geopoints data and makes them conform to process properly
 * @param {Array} points
 * @returns {GeoPoint[]}
 */
const createGeoPoints = (points) => {
    return points.map((point, idx) => {
        return createGeoPoint(point.latitude, point.longitude, point.distance, idx);
    });
};

/**
 * The main method -- Determines the possible course points that are near to the selected point. The selected
 * point must be on the course polyline. It uses bounding box intersection to find the possible line segments
 * that could contain the course point.
 *
 * If the selectedPoint is outside the course polyline, the algorithm won't identify any course points.
 *
 * The keys for latitude and longitude that API uses for the selected Course Point and the list of Geo Points
 * are different. This is accounted for with the helper functions
 *
 * @param {Object} selectedPoint - The Course Point point object the user selected (API = 'lat' and 'lon')
 * @param {Array} geoPoints - the raw data of geo points (API = 'latitude' and 'longitude')
 * @param {number} [lineLength] - length of the line used to check for intersecting points. Configurable
 * @returns {GeoPoint[]}
 *
 */
export const findNearByCoursePoints = (selectedPoint, geoPoints, lineLength = COURSE_POINT_DEFAULT_LENGTH) => {
    // Result variable that will hold the candidate course points
    /** @type {GeoPoint[]} */
    const candidateCoursePoints = [];

    /** @type {GeoPoint} */
    const selectedGeoPoint = createGeoPoint(selectedPoint.lat, selectedPoint.lon, selectedPoint.distance);

    /** @type {GeoPoint[]} */
    const GeoPoints = createGeoPoints(geoPoints);

    // Calculate the coordinates of the points that are 10 meters away from the selected point
    const verticalLineStart = computeOffset(selectedGeoPoint, lineLength, 0);
    const verticalLineEnd = computeOffset(selectedGeoPoint, -lineLength, 0);
    const horizontalLineStart = computeOffset(selectedGeoPoint, lineLength, 90);
    const horizontalLineEnd = computeOffset(selectedGeoPoint, -lineLength, 90);

    const vertBBox = buildSegmentBoundingBox(verticalLineStart, verticalLineEnd);
    const horizBBox = buildSegmentBoundingBox(horizontalLineStart, horizontalLineEnd);

    // Iterate over each geo point in the course assuming they are in order
    for (let i = 0; i < GeoPoints.length - 1; i++) {
        // Iterating over each line segment of the course
        const start = GeoPoints[i];
        const end = GeoPoints[i + 1];
        const lineSegmentBBox = buildSegmentBoundingBox(start, end);

        start.index = i;
        end.index = i + 1;

        // Check if the line segment intersects with the vertical or horizontal line
        if (doesBBoxIntersect(vertBBox, lineSegmentBBox) || doesBBoxIntersect(horizBBox, lineSegmentBBox)) {
            // Find the closest point on the line segment to the selected point
            const closestPoint = closestPointOnLineSegment(start, end, selectedGeoPoint);

            // Distance between the selected point and the closest point
            const closestPointDistance = computeDistance(selectedGeoPoint, closestPoint);

            // If the identified course point is out of distance buffer configuration, ignore it
            if (closestPointDistance < COURSE_POINT_DISTANCE_BUFFER_METERS) {
                // Compute and set the course distance for the course point
                closestPoint.distance = start.distance + computeDistance(start, closestPoint);

                // Add the course point to the candidate list
                candidateCoursePoints.push(closestPoint);
            }
        }
    }

    const filteredPoints = groupAndFindClosestPoints(selectedGeoPoint, candidateCoursePoints);

    return filteredPoints;
};

/**
 * @param {GeoPoint} point
 * @param {number} distance - line length distance in meters
 * @param {number} heading - in degrees
 * @returns {GeoPoint}
 */
const computeOffset = (point, distance, heading) => {
    const radiusEarth = 6371000; // Earth's radius in meters
    const distanceRatio = distance / radiusEarth;
    const headingRadians = (heading * Math.PI) / 180;

    const lat1 = (point.lat * Math.PI) / 180;
    const lon1 = (point.lon * Math.PI) / 180;

    const lat2 = Math.asin(
        Math.sin(lat1) * Math.cos(distanceRatio) + Math.cos(lat1) * Math.sin(distanceRatio) * Math.cos(headingRadians)
    );
    const lon2 =
        lon1 +
        Math.atan2(
            Math.sin(headingRadians) * Math.sin(distanceRatio) * Math.cos(lat1),
            Math.cos(distanceRatio) - Math.sin(lat1) * Math.sin(lat2)
        );

    /** @type {GeoPoint} */
    return createGeoPoint((lat2 * 180) / Math.PI, (lon2 * 180) / Math.PI, point.distance);
};

/**
 * For dense geo points (like in the case of activity saved into Course), the algorithm may detect multiple
 * points in close proximity.
 *
 * In some cases tested it was just 1 or 2 meters apart, it may not make sense to show all of them as
 * candidate points.
 *
 * This method filters the points based on the distance threshold (assuming it as 10 meters - Configurable for
 * what reasonably works).
 *
 * @param {GeoPoint} selectedGeoPoint
 * @param {GeoPoint[]} candidateGeoPoints
 * @returns {GeoPoint[]}
 */
const groupAndFindClosestPoints = (selectedGeoPoint, candidateGeoPoints) => {
    if (candidateGeoPoints.length <= 1) {
        return candidateGeoPoints;
    }

    // Sort points by distance from the start
    candidateGeoPoints.sort((a, b) => a.distance - b.distance);

    /** @type {GeoPoint[]} */
    const resultGroup = [];

    /** @type {GeoPoint[]} */
    let group = [];

    for (let i = 0; i < candidateGeoPoints.length; i++) {
        if (group.length === 0) {
            group.push(candidateGeoPoints[i]);
        } else {
            const lastPoint = group[group.length - 1];
            if (candidateGeoPoints[i].distance - lastPoint.distance <= COURSE_POINT_DISTANCE_THRESHOLD_METERS) {
                group.push(candidateGeoPoints[i]);
            } else {
                const closestPoint = findClosestPoint(selectedGeoPoint, group);
                resultGroup.push(closestPoint);
                group = [candidateGeoPoints[i]]; // Start a new group
            }
        }
    }

    // Add the last group
    if (group.length > 0) {
        const closestPoint = findClosestPoint(selectedGeoPoint, group);
        resultGroup.push(closestPoint);
    }
    return resultGroup;
};

/**
 *
 * @param {GeoPoint} selectedGeoPoint
 * @param {GeoPoint[]} candidateGeoPoints
 * @returns {GeoPoint}
 */
const findClosestPoint = (selectedGeoPoint, candidateGeoPoints) => {
    return candidateGeoPoints.reduce((prev, current) => {
        return computeDistance(selectedGeoPoint, prev) < computeDistance(selectedGeoPoint, current) ? prev : current;
    });
};

/**
 * Used to find the closest point on a line segment to the selected point.
 * It is possible that BBoxes could overlap but the selected point mayn't in the line segment itself.
 *
 * This method calculates the closest point on the line segment to the selected point.
 *
 * @param {GeoPoint} start
 * @param {GeoPoint} end
 * @param {GeoPoint} selected
 * @returns {GeoPoint}
 */
const closestPointOnLineSegment = (start, end, selected) => {
    const startX = degreesToRadians(start.lon);
    const startY = degreesToRadians(start.lat);
    const endX = degreesToRadians(end.lon);
    const endY = degreesToRadians(end.lat);
    const selX = degreesToRadians(selected.lon);
    const selY = degreesToRadians(selected.lat);

    // Vector from start to end
    const lineDX = endX - startX;
    const lineDY = endY - startY;

    // Vector from start to selected point
    const pointDX = selX - startX;
    const pointDY = selY - startY;

    // Calculate the dot product of the vectors
    const dotProduct = pointDX * lineDX + pointDY * lineDY;

    // Calculate the length squared of the line segment
    const lengthSquared = lineDX * lineDX + lineDY * lineDY;

    // Calculate the projection factor (t) of the selected point onto the line
    let t = dotProduct / lengthSquared;

    // If the selected point projects outside the line segment, clamp it to the nearest endpoint
    if (t < 0) {
        t = 0;
    } else if (t > 1) {
        t = 1;
    }

    // Calculate the closest point coordinates
    const closestX = startX + t * lineDX;
    const closestY = startY + t * lineDY;

    /** @type {GeoPoint} */
    return createGeoPoint(radiansToDegrees(closestY), radiansToDegrees(closestX), 0, start.index);
};

/**
 *
 * @param {GeoPoint} start
 * @param {GeoPoint} end
 * @returns {Bbox}
 */
const buildSegmentBoundingBox = (start, end) => {
    const segmentBoundingBox = {
        minX: Math.min(start.lon, end.lon),
        maxX: Math.max(start.lon, end.lon),
        minY: Math.min(start.lat, end.lat),
        maxY: Math.max(start.lat, end.lat)
    };

    return segmentBoundingBox;
};

/**
 *
 * @param {Bbox} pointBoundingBox
 * @param {Bbox} segmentBoundingBox
 * @returns {boolean}
 */
const doesBBoxIntersect = (pointBoundingBox, segmentBoundingBox) => {
    return (
        pointBoundingBox.minX <= segmentBoundingBox.maxX &&
        pointBoundingBox.maxX >= segmentBoundingBox.minX &&
        pointBoundingBox.minY <= segmentBoundingBox.maxY &&
        pointBoundingBox.maxY >= segmentBoundingBox.minY
    );
};

const degreesToRadians = (degrees) => {
    return (degrees * Math.PI) / 180;
};

const radiansToDegrees = (radians) => {
    return (radians * 180) / Math.PI;
};

/**
 * Compute distance between to points using our helper method. Ultimately,
 * this uses Leaflet's built in 'distanceTo' method
 *
 * To be returned in meters.
 *
 * @param {GeoPoint} start
 * @param {GeoPoint} end
 * @returns {number}
 */
const computeDistance = (start, end) => {
    return MapUtil.calculateDistanceBetweenPointsInMeters(start.lat, start.lon, end.lat, end.lon);
};

/**
 * Description: Return a CourseDTO with Lap by CoursePoints either added, updated, or removed
 * @param {CourseDTO} editableCourseDetails // current course data object
 * @param {boolean} lapPointsOn // true = calculate lap points, false = remove them
 * @returns {CourseDTO}
 */
export const updateLapByCoursePoints = (editableCourseDetails, lapPointsOn) => {
    const newCoursePoints = [];
    const nonLapByCoursePoints =
        editableCourseDetails?.coursePoints?.filter((point) => {
            return ![MARKER_MILE, MARKER_KILOMETER, MARKER_HALF_MARATHON].includes(point.coursePointType);
        }) || [];

    // don't calculate lap points if course is > 150 miles
    if (
        lapPointsOn &&
        editableCourseDetails?.distanceMeter <= Conversion.convertDistance(150, DistanceUnits.mile, DistanceUnits.meter)
    ) {
        const mileCoursePoints = [];
        const kmCoursePoints = [];
        const halfMarathonPoints = [];

        for (let i = 0; i < editableCourseDetails?.geoPoints?.length; i++) {
            const currentPoint = editableCourseDetails.geoPoints[i];

            // stop at 150 miles for all mi/km/half points, value is in meters 241,402 meters ~= 150 miles
            if (currentPoint.distance > 241402) {
                break;
            }

            // keep lap points 0.4% away from the end of the course
            if (currentPoint.distance < editableCourseDetails.distanceMeter * 0.996) {
                // add 1mi course points
                if (currentPoint.distance >= 1609.34 * (mileCoursePoints.length + 1)) {
                    const prevPoint = editableCourseDetails.geoPoints[i - 1];

                    // adjust for when actual distance falls between prev/current lat/lon
                    const bearing = MapsUtil.calculateBearingOfPoints(
                        prevPoint.latitude,
                        prevPoint.longitude,
                        currentPoint.latitude,
                        currentPoint.longitude
                    );
                    const distToActualPoint = 1609.34 * (mileCoursePoints.length + 1) - prevPoint.distance;
                    const [lat, lon] = MapsUtil.calculateDestinationPoint(
                        prevPoint.latitude,
                        prevPoint.longitude,
                        distToActualPoint / 1000,
                        bearing,
                        true
                    );
                    mileCoursePoints.push({
                        name: `${mileCoursePoints.length + 1} ${i18next.t('units:distance.mile')}`,
                        coursePointType: MARKER_MILE,
                        lon,
                        lat,
                        distance: prevPoint.distance + distToActualPoint,
                        elevation: currentPoint.elevation
                    });
                }

                // add 1km course points
                if (currentPoint.distance >= 1000 * (kmCoursePoints.length + 1)) {
                    const prevPoint = editableCourseDetails.geoPoints[i - 1];

                    // adjust for when actual distance falls between prev/current lat/lon
                    const bearing = MapsUtil.calculateBearingOfPoints(
                        prevPoint.latitude,
                        prevPoint.longitude,
                        currentPoint.latitude,
                        currentPoint.longitude
                    );
                    const distToActualPoint = 1000 * (kmCoursePoints.length + 1) - prevPoint.distance;
                    const [lat, lon] = MapsUtil.calculateDestinationPoint(
                        prevPoint.latitude,
                        prevPoint.longitude,
                        distToActualPoint / 1000,
                        bearing,
                        true
                    );
                    kmCoursePoints.push({
                        name: `${kmCoursePoints.length + 1} ${i18next.t('units:distance.kilometer')}`,
                        coursePointType: MARKER_KILOMETER,
                        lon,
                        lat,
                        distance: prevPoint.distance + distToActualPoint,
                        elevation: currentPoint.elevation
                    });
                }

                // add half marathon course points every 13.11 miles
                if (currentPoint.distance >= 21097.5 * (halfMarathonPoints.length + 1)) {
                    const prevPoint = editableCourseDetails.geoPoints[i - 1];

                    // adjust for when actual distance falls between prev/current lat/lon
                    const bearing = MapsUtil.calculateBearingOfPoints(
                        prevPoint.latitude,
                        prevPoint.longitude,
                        currentPoint.latitude,
                        currentPoint.longitude
                    );
                    const distToActualPoint = 21097.5 * (halfMarathonPoints.length + 1) - prevPoint.distance;
                    const [lat, lon] = MapsUtil.calculateDestinationPoint(
                        prevPoint.latitude,
                        prevPoint.longitude,
                        distToActualPoint / 1000,
                        bearing,
                        true
                    );
                    halfMarathonPoints.push({
                        name: `${halfMarathonPoints.length + 1} ${i18next.t('pacepro:pacepro_half_marathon')}`,
                        coursePointType: MARKER_HALF_MARATHON,
                        lon,
                        lat,
                        distance: prevPoint.distance + distToActualPoint,
                        elevation: currentPoint.elevation
                    });
                }
            }
        }

        newCoursePoints.push(...mileCoursePoints);
        newCoursePoints.push(...kmCoursePoints);
        newCoursePoints.push(...halfMarathonPoints);
    }

    return {
        ...editableCourseDetails,
        coursePoints: [...nonLapByCoursePoints, ...newCoursePoints]
    };
};

export const courseHasLapByCoursePoints = (courseData) => {
    return courseData?.coursePoints?.some((point) => {
        return [MARKER_MILE, MARKER_KILOMETER, MARKER_HALF_MARATHON].includes(point?.coursePointType);
    });
};

/**
 * Description: Does any course point have a truthy value for the passed in field
 * @param {object} courseData
 * @param {string} field // field to search course points for a truthy value
 * @returns {boolean}
 */
export const courseHasPointWithData = (courseData, field) => {
    return courseData?.coursePoints?.some((point) => {
        return !!point[field];
    });
};

/**
 * Description: return true if the course point type is one of the Lap by Course Point types
 * @param {string} coursePointType
 * @returns {boolean}
 */
export const isLapByCoursePointsType = (coursePointType) => {
    return [MARKER_MILE, MARKER_KILOMETER, MARKER_HALF_MARATHON].includes(coursePointType);
};
